import React, { useEffect, useRef, useState } from 'react';
import { eachDayOfInterval, format, addDays, getDay, isToday } from 'date-fns';
import { checkAddPermission, checkEditPermission, checkDeletePermission, transformData } from '../../../Utils/helper';
import { renderPrepackProductData } from './renderPrepackProductData';
import { renderPrepackProductGroupSection } from './renderPrepackProductGroupSection';
import { getApi, postApi, deleteApi } from '../../../Services/apiService';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Select, Tooltip, Modal } from 'antd';
import CellContextMenu from '../CellContextMenu/CellContextMenu';
import CellRemarkModal from '../CellRemark/CellRemarkModal';
import { buildCellData, handleCellContextMenu, closeContextMenu, cellHasRemarks, getCellDataAttributes } from '../../../Utils/cellRemarkHelper';
import ConvertOutModal from '../Shared/ConvertOutModal';
import ConvertOutHistoryModal from '../ConvertOutHistoryModal/ConvertOutHistoryModal';
import AddEditArrival from '../Arrival/addEditArrival';
import { getCanonicalTimezone } from '../../../Utils/helper';
const { Option } = Select;
// --- FlexHeaderCell: column-reverse only when content overflows (one-way latch) ---
const FlexHeaderCell = ({ children }) => {
  const ref = useRef(null);
  const [overflow, setOverflow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Only ever latch to true — never reset back to false, so no feedback loop
    const check = () => {
      if (el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth) {
        setOverflow(true);
      }
    };
    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={ref} className='main-addproduct-cs' style={overflow ? { flexDirection: 'column-reverse' } : {}}>
      {children}
    </div>
  );
};

// --- TableHeader Subcomponent ---
const TableHeader = ({
  maxArrivalsCount,
  showAllArrivals,
  setShowAllArrivals,
  salesColumns,
  salesColumnsWithData,
  showGroupData,
  selectedGroupProducts,
  productsByGroupId,
  productSalesHeaders,
  handleGroupToggle,
  handleAddColumnClick,
  combinedOrderedColumns,
  handleInlineAddReserve,
  handleInlineAddArrival,
  permissions,
  hiddenReserveGroups,
  toggleReserveGroup,
  handleDeleteColumnClick
}) => {

  return (
    <thead>
      {(maxArrivalsCount > 0 || salesColumns?.length > 0 || productSalesHeaders?.length > 0) &&
        //first row
        <tr>
          {(maxArrivalsCount > 0 || salesColumns?.length > 0 || productSalesHeaders?.length > 0) && (
            <th colSpan={3} className="blank-row"></th>
          )}

          {maxArrivalsCount > 0 && (
            <th colSpan={showAllArrivals ? maxArrivalsCount : 1}
              style={{
                left: `${maxArrivalsCount <= 5 ? `${237}px` : ''}`,
                position: `${maxArrivalsCount <= 5 ? 'sticky' : ''}`,
                width: `${maxArrivalsCount <= 5 ? '5%' : ''}`,
                zIndex: `${maxArrivalsCount <= 5 ? '999' : ''}`,
              }}
              className="arrival-bg arival-info"
            >
              <div className='grouping' style={{ display: 'inline-block' }}>
                {maxArrivalsCount > 1 && (
                  <label className="checbox-cs" style={{ marginRight: '6px', display: 'inline-block' }}>
                    <input
                      type="checkbox"
                      checked={showAllArrivals}
                      onChange={() => setShowAllArrivals((prev) => !prev)}
                    />
                    <span className="checkmark" style={{ top: '9px' }}></span>
                  </label>
                )}
                Arrival
              </div>
            </th>
          )}
          {/* Combined ordered columns - groups and products in original order */}
          {combinedOrderedColumns.map((item, idx) => {
            if (item.type === 'group') {
              const group = item.data;
              const isGroupReserveHidden = hiddenReserveGroups?.has(group?.productGroupkey);
              const reserveColSpan = group.groupNames?.reduce((sum, cg) => sum + (cg.subGroups?.length || 0), 0) || 0;
              const visibleColSpan = isGroupReserveHidden ? group.colSpan - reserveColSpan : group.colSpan;
              return (
                <React.Fragment key={`group-${idx}-${group.productGroupkey}`}>
                  <th className={`sales-bg sales-header ${idx === 0 ? 'first_sales_bg' : ''} ${(group?.orderArrivalData?.next_order_date && group?.orderArrivalData?.next_eta) ? '' : ' single-sale-check  no-group-found'}`} colSpan={visibleColSpan + 1 + (group?.groupNames?.length > 0 ? 0 : 1)}>
                    <>

                      <FlexHeaderCell>
                        <div className='pluss-add'>
                          <img className='bg-white' onClick={() => handleAddColumnClick(group?.maiProductGroup?.[0]?.product_id, group?.groupNames, group?.productGroupkey, group?.prepackProductType, group?.finishedProductCodes)} src={window.getPublicUrl(`/assets/images/plus-blue.svg`)} alt="" />
                          {handleInlineAddReserve && checkAddPermission(permissions, 'reserve') && (
                            <Tooltip title="Add Reserve">
                              <img
                                className="bg-white ms-1 cursor-pointer"
                                src={window.getPublicUrl(`/assets/images/green-reserve.svg`)}
                                onClick={() => {
                                  let refreshIds = group?.maiProductGroup?.[0]?.product_id;
                                  if (group?.prepackProductType == 0) {
                                    refreshIds = Object.keys(group.finishedProductCodes || {});
                                  } else if (group?.prepackProductType == 2) {
                                    refreshIds = [group?.maiProductGroup?.[0]?.product_id, ...Object.keys(group.finishedProductCodes || {})];
                                  }
                                  handleInlineAddReserve(
                                    group?.maiProductGroup?.[0]?.product_id,
                                    group?.maiProductGroup?.[0]?.name_tc,
                                    group?.maiProductGroup?.[0]?.code,
                                    refreshIds
                                  );
                                }}
                                alt="Add Reserve"
                                style={{ width: '30px', height: '30px' }}
                              />
                            </Tooltip>
                          )}
                          {handleInlineAddArrival && checkAddPermission(permissions, 'arrival') && (
                            <Tooltip title="Add Arrival">
                              <img
                                className="bg-white ms-1 cursor-pointer"
                                src={window.getPublicUrl(`/assets/images/total-arrive.svg`)}
                                onClick={() => {
                                  let refreshIds = group?.maiProductGroup?.[0]?.product_id;
                                  if (group?.prepackProductType == 0) {
                                    refreshIds = Object.keys(group.finishedProductCodes || {});
                                  } else if (group?.prepackProductType == 2) {
                                    refreshIds = [group?.maiProductGroup?.[0]?.product_id, ...Object.keys(group.finishedProductCodes || {})];
                                  }
                                  handleInlineAddArrival(
                                    group?.maiProductGroup?.[0]?.product_id,
                                    group?.maiProductGroup?.[0]?.name_tc,
                                    group?.maiProductGroup?.[0]?.code,
                                    refreshIds
                                  );
                                }}
                                alt="Add Arrival"
                                style={{ width: '30px', height: '30px' }}
                              />
                            </Tooltip>
                          )}
                          <Tooltip title={hiddenReserveGroups?.has(group?.productGroupkey) ? 'Show Reserve' : 'Hide Reserve'}>
                            <button
                              className="bg-white ms-1 cursor-pointer"
                              style={{ width: '30px', height: '30px', border: '1px solid #ccc', borderRadius: '4px', fontWeight: 'bold', fontSize: '16px', lineHeight: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                              onClick={() => toggleReserveGroup(group?.productGroupkey)}
                            >
                              {hiddenReserveGroups?.has(group?.productGroupkey) ? '+' : '-'}
                            </button>
                          </Tooltip>
                        </div>
                        <div className='pluss-add'>
                          {group?.orderArrivalData?.next_order_date && <h6>Next Order Date :{group?.orderArrivalData?.next_order_date}</h6>}
                          {group?.orderArrivalData?.next_eta && <h6>Next ETA : {group?.orderArrivalData?.next_eta}</h6>}
                          <p> {`Sales Reserve -> Update/Delivery (Group No : ${group.productGroupId})`}</p>
                          {group?.maiProductGroup?.[0]?.name_tc && <p>Main Product: {group?.maiProductGroup?.[0]?.name_tc} {(group?.groupNames?.length <= 0) && group?.maiProductGroup?.[0]?.code}</p>}
                          {/* PA Code : 
                              Barcode :  */}
                          {/* {(group?.prepackProductType == 1 || group?.prepackProductType == 2) && 
                          <>
                            <p className='red-font '>PA Code : {group?.paCode}</p>
                            <p className='red-font '>Barcode : {group?.barcode}</p>
                          </>
                          } */}
                        </div>
                      </FlexHeaderCell>
                    </>
                  </th>
                  {group?.groupNames?.length > 0 && <th key={`group-${idx}-code`} className="sales-bg sale-highlight"> {group?.maiProductGroup?.[0]?.name_tc && <p>({group?.maiProductGroup?.[0]?.code})</p>}</th>}
                  <th key={`group-${idx}-group`} className={`sales-bg sale-group ${(showGroupData != null) ? showGroupData !== group?.productGroupkey ? 'not-check' : '' : 'not-check'}`} colSpan={2}>
                    <div className="grouping">
                      {productsByGroupId.find(g => g.groupId === group.productGroupkey)?.products?.products?.length > 0 && (
                        <label className="checbox-cs">
                          <input
                            type="checkbox"
                            onChange={() => handleGroupToggle(group.productGroupkey, 'group')}
                            checked={showGroupData === group.productGroupkey}
                          />
                          <span className="checkmark"></span>
                        </label>
                      )}
                      Grouping
                    </div>
                  </th>

                  {showGroupData === group?.productGroupkey && (
                    <>
                      {selectedGroupProducts[group?.productGroupkey]?.products?.products
                        .filter((product, index, self) =>
                          index === self.findIndex(p => p.id === product.id))
                        .map((product, index, arr) => (
                          <th style={{ borderRight: '1px solid #000' }}
                            key={`product-${product.id}`}
                            className={`${index === arr.length - 1 ? 'not-check ' : ''}`}
                          >
                            <p style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'pre-line',
                              maxHeight: '58px'
                            }}>{product.product_name_tc || 'N/A'}</p>
                            <p style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'pre-line',
                              maxHeight: '30px'
                            }}>({product.code || 'N/A'})</p>
                          </th>
                        ))
                      }
                    </>
                  )}
                </React.Fragment>
              );
            } else if (item.type === 'product') {
              const group = item.data;
              return (
                <React.Fragment key={`product-${idx}-${group.productGroupOriginalId}`}>
                  <th
                    className={`sales-bg ${idx === 0 ? 'first_sales_bg' : ''} ${group?.customerGroups?.length > 0 ? '' : 'no-group-found'} single-sale-check`}
                    colSpan={group.totalColSpan + 1 + 1}
                  >
                    <FlexHeaderCell>
                      <div className="pluss-add">
                        <img className='bg-white ' onClick={() => handleAddColumnClick(group.productGroupOriginalId, group?.customerGroups, null, group?.prepackProductType, group?.finishedProductCodes)} src={window.getPublicUrl(`/assets/images/plus-blue.svg`)} alt="" />
                        {handleInlineAddReserve && checkAddPermission(permissions, 'reserve') && (
                          <Tooltip title="Add Reserve">
                            <img
                              className="bg-white ms-1 cursor-pointer"
                              src={window.getPublicUrl(`/assets/images/green-reserve.svg`)}
                              onClick={() => {
                                let refreshIds = group.productGroupOriginalId;
                                if (group?.prepackProductType == 0) {
                                  refreshIds = Object.keys(group.finishedProductCodes || {});
                                } else if (group?.prepackProductType == 2) {
                                  refreshIds = [group.productGroupOriginalId, ...Object.keys(group.finishedProductCodes || {})];
                                }
                                handleInlineAddReserve(
                                  group.productGroupOriginalId,
                                  group.productGroupId,
                                  group.productCode,
                                  refreshIds
                                );
                              }}
                              alt="Add Reserve"
                              style={{ width: '30px', height: '30px' }}
                            />
                          </Tooltip>
                        )}
                        {handleInlineAddArrival && checkAddPermission(permissions, 'arrival') && (
                          <Tooltip title="Add Arrival">
                            <img
                              className="bg-white ms-1 cursor-pointer"
                              src={window.getPublicUrl(`/assets/images/total-arrive.svg`)}
                              onClick={() => {
                                let refreshIds = group.productGroupOriginalId;
                                if (group?.prepackProductType == 0) {
                                  refreshIds = Object.keys(group.finishedProductCodes || {});
                                  console.log('product type is 0, refresh id is', refreshIds)
                                } else if (group?.prepackProductType == 2) {
                                  refreshIds = [group.productGroupOriginalId, ...Object.keys(group.finishedProductCodes || {})];
                                  console.log('product type is 2, refresh id is', refreshIds)
                                }
                                handleInlineAddArrival(
                                  group.productGroupOriginalId,
                                  group.productGroupId,
                                  group.productCode,
                                  refreshIds
                                );
                              }}
                              alt="Add Arrival"
                              style={{ width: '30px', height: '30px' }}
                            />
                          </Tooltip>
                        )}
                        <Tooltip title={hiddenReserveGroups?.has(group?.productGroupOriginalId) ? 'Show Reserve' : 'Hide Reserve'}>
                          <button
                            className="bg-white ms-1 cursor-pointer"
                            style={{ width: '30px', height: '30px', border: '1px solid #ccc', borderRadius: '4px', fontWeight: 'bold', fontSize: '16px', lineHeight: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                            onClick={() => toggleReserveGroup(group?.productGroupOriginalId)}
                          >
                            {hiddenReserveGroups?.has(group?.productGroupOriginalId) ? '+' : '-'}
                          </button>
                        </Tooltip>
                      </div>
                      <div className="pluss-add">
                        {group?.orderArrivalData?.next_order_date && <h6>Next Order Date :{group?.orderArrivalData?.next_order_date}</h6>}
                        {group?.orderArrivalData?.next_eta && <h6>Next ETA : {group?.orderArrivalData?.next_eta}</h6>}
                        <p>{`Sales Reserve -> Update/Delivery`}<br /> {`(Product: ${group.productGroupId}) - ${group.productCode}`}</p>
                        {(group?.prepackProductType == 1 || group?.prepackProductType == 2) &&
                          <>
                            <p className='red-font '>Prepack Type : {group?.prepackTypes}</p>
                            <p className='red-font '>PA Code : {group?.paCode}</p>
                            <p className='red-font '>Barcode : {group?.barcode}</p>
                          </>
                        }
                      </div>
                    </FlexHeaderCell>
                  </th>
                  <th
                    key={`product-group-${idx}-group`}
                    className="sales-bg sale-group not-check"
                    colSpan={2}
                  >
                    <div className="grouping">
                      Grouping
                    </div>
                  </th>
                  {showGroupData === group?.productGroupOriginalId && (
                    <>
                      {Object.entries(selectedGroupProducts[group?.productGroupOriginalId] || {})
                        .flatMap(([date, products]) => products)
                        .filter((product, index, self) =>
                          index === self.findIndex(p => p.id === product.id))
                        .map((product) => (
                          <th
                            key={`product-${product.id}`}
                            className=""
                          >
                            <p>{product.product_name_tc || 'N/A'}</p>
                          </th>
                        ))
                      }
                    </>
                  )}
                </React.Fragment>
              );
            }
            return null;
          })}
        </tr>
      }
      {/* second row */}
      <tr className='scond-differnt-header first-row'>
        <th rowSpan="2" className="sticky-col">ETA</th>
        <th rowSpan="2" className="arrival-bg sticky-col">Delivery Date</th>
        <th rowSpan="2" className={`sales-bg sticky-col ${maxArrivalsCount <= 0 ? 'not-arrival-qty' : ''}`}>Day</th>

        {maxArrivalsCount > 0 && (showAllArrivals ? Array.from({ length: maxArrivalsCount }) : [0]).map((_, idx) => (
          <th
            className={`arrival-bg arival-info ${maxArrivalsCount === (idx + 1) ? 'last_arrival_info' : `${showAllArrivals ? '' : 'last_arrival_info'}`}`}
            key={idx}
            rowSpan={2}
            style={{
              left: `${maxArrivalsCount > 0 ? `${158 + ((idx + 1) * 79)}px` : ''}`,
              // left: `${158 + ((idx + 1) * 79)}px`,
              position: `${maxArrivalsCount > 0 ? 'sticky' : ''}`,
              width: `${maxArrivalsCount > 0 ? '5%' : ''}`,//'5%',
              zIndex: `${maxArrivalsCount > 0 ? '999' : ''}`,
              position: `${maxArrivalsCount > 0 ? 'sticky' : ''}`,
              width: `${maxArrivalsCount > 0 ? '5%' : ''}`,//'5%',
              zIndex: `${maxArrivalsCount > 0 ? '999' : ''}`,
            }}
          >
            Arrival Info {idx + 1}
          </th>
        ))}
        {/*  second row - combined ordered groups and products */}
        {combinedOrderedColumns.flatMap((item, idx) => {

          if (item.type === 'group') {
            const group = item.data;
            return (
              <React.Fragment key={`group-row2-${idx}-${group.productGroupkey}`}>
                {salesColumnsWithData?.length > 0 &&
                  <th className={`arrival-bg arival-qty-ui `} rowSpan="2">Arrival Qty</th>
                }
                {(group?.prepackProductType == 1 || group?.prepackProductType == 2) && <th className="arrival-bg arival-qty-ui convert-in-column" rowSpan="2">Convert In</th>}
                {!hiddenReserveGroups?.has(group?.productGroupkey) && group.groupNames.map((customerGroup, groupSubIdx) => {
                  const isLastSubgroup = idx === group.length - 1;
                  return (
                    <React.Fragment key={`customer-group-${idx}-${groupSubIdx}`}>
                      {customerGroup.subGroups.map((subgroup, subIdx) => {
                        return (
                          <React.Fragment key={`subgroup-${idx}-${groupSubIdx}-${subIdx}`}>
                            <th className="sales-bg" key={`subgroup-${idx}-${groupSubIdx}-${subIdx}`}>
                              {customerGroup.name} {/* label name **/}
                            </th>
                          </React.Fragment>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
                {/* {(group?.prepackProductType == 0 || group?.prepackProductType == 2) &&
                  typeof group?.finishedProductCodes === 'object' && (
                    <th key={`convert-out-${idx}`} className="arrival-bg arival-qty-ui convert-out-column" rowSpan="2">
                      Convert Out
                      {Object.keys(group?.finishedProductCodes || {}).length > 0 && (
                        <><br />{Object.values(group?.finishedProductCodes).join(', ')}</>
                      )}
                    </th>
                  )
                } */}
                {(group.prepackProductType == 0 || group.prepackProductType == 2) &&
                  typeof group.finishedProductCodes === 'object' && Object.entries(group.finishedProductCodes)?.map(([id, code], index) => (
                    <th key={`convert-out-${code}-${index}`} className="arrival-bg arival-qty-ui convert-out-column" rowSpan="2">
                      <Tooltip color="#FFEAEA" title={
                        <div>
                          {group.finishedProductNames?.[id] || ''}
                          {group.finishedProductConvertRatios?.[id] && (
                            <>
                              <br />
                              Convert Ratio: {group.finishedProductConvertRatios?.[id]}
                            </>
                          )}
                        </div>
                      } overlayInnerStyle={{ color: 'black' }}>
                        <span style={{ color: 'black' }}>Convert Out<br />{code}</span>
                      </Tooltip>
                    </th>
                  ))
                }

                {/* {group.groupNames?.length > 0 && <th className="sales-bg" rowSpan={2}>Total Qty</th>} */}
                <th className="sales-bg" rowSpan={2}>Total Qty</th>
                {salesColumnsWithData?.length > 0 &&
                  <>
                    <th rowSpan="2" className='estimate-stock'>Estimate Stock</th>
                    <th className={`stock-bg actual-stock ${(showGroupData !== null) ? showGroupData !== group?.productGroupkey ? 'not-check' : '' : 'not-check'}`} rowSpan="2">Actual Stock</th>
                    {showGroupData !== null &&
                      showGroupData === group?.productGroupkey &&
                      selectedGroupProducts[group?.productGroupkey]?.products &&
                      [...new Map(
                        selectedGroupProducts[group.productGroupkey].products?.products
                          .map(product => [product.id, product]) // Deduplicate by `id`
                      ).values()].map((product, index, arr) => (
                        <th key={`balance-${product.id}-${index}`} className={`stock-bg actual-stock-balane ${index === arr.length - 1 ? 'not-check' : ''}`} rowSpan="2">
                          Actual Stock
                        </th>
                      ))}
                  </>
                }
              </React.Fragment>
            );
          } else if (item.type === 'product') {
            const productGroup = item.data;
            return (
              <React.Fragment key={`product-row2-${idx}-${productGroup.productGroupOriginalId}`}>
                <th className="arrival-bg arival-qty-ui" rowSpan="2">Arrival Qty</th>
                {(productGroup.prepackProductType == 1 || productGroup.prepackProductType == 2) && <th className="arrival-bg arival-qty-ui convert-in-column" rowSpan="2">Convert In</th>}
                {!hiddenReserveGroups?.has(productGroup?.productGroupOriginalId) && productGroup.customerGroups.flatMap((customerGroup, customerIdx) => {
                  return customerGroup.subGroups.map((subgroup, subIdx) => {
                    const isLastSubgroup = subIdx === customerGroup.subGroups.length - 1;
                    const isLastCustomerGroup = customerIdx === productGroup.customerGroups.length - 1;

                    return (
                      <React.Fragment key={`subgroup-${idx}-${customerIdx}-${subIdx}`}>
                        <th className="sales-bg">
                          {customerGroup.customerGroupName}
                        </th>
                      </React.Fragment>
                    );
                  });
                })}
                {(productGroup.prepackProductType == 0 || productGroup.prepackProductType == 2) &&
                  typeof productGroup.finishedProductCodes === 'object' && Object.entries(productGroup.finishedProductCodes)?.map(([id, code], index) => (
                    <th key={`convert-out-${code}-${index}`} className="arrival-bg arival-qty-ui convert-out-column" rowSpan="2">
                      <Tooltip color="#FDE6FA" title={
                        <div>
                          {productGroup.finishedProductNames?.[id] || ''}
                          {productGroup.finishedProductConvertRatios?.[id] && (
                            <>
                              <br />
                              Convert Ratio: {productGroup.finishedProductConvertRatios?.[id]}
                            </>
                          )}
                        </div>
                      } overlayInnerStyle={{ color: 'black' }}>
                        <span style={{ color: 'black' }}>Convert Out<br />{code}</span>
                      </Tooltip>
                    </th>
                  ))
                }

                <th className="sales-bg" rowSpan={2}>Total Qty</th>

                {productSalesHeaders?.length > 0 &&
                  <>
                    <th rowSpan="2" className='estimate-stock'>Estimate Stock</th>
                    <th className="stock-bg actual-stock not-check" rowSpan="2">Actual Stock</th>
                    {(showGroupData !== null && showGroupData === productGroup?.productGroupOriginalId) &&
                      <th key={`balance-{productId}`} className="stock-bg actual-stock-balane" rowSpan="2">
                        Actual Stock
                      </th>
                    }
                  </>
                }
              </React.Fragment>
            );
          }
          return null;
        })}

      </tr>
      {/* third row for group names - combined ordered */}
      <tr className="scond-differnt-header">
        {combinedOrderedColumns.flatMap((item, idx) => {
          if (item.type === 'group') {
            const group = item.data;
            return (
              <React.Fragment key={`group-row3-${idx}-${group.productGroupkey}`}>
                {!hiddenReserveGroups?.has(group?.productGroupkey) && group.groupNames.map((customerGroup, customerGroupIdx) => {
                  return (
                    <React.Fragment key={`customer-group-${idx}-${customerGroupIdx}`}>
                      {customerGroup.subGroups.map((subgroup, subIdx) => {
                        return (
                          <React.Fragment key={`subgroup-${idx}-${customerGroupIdx}-${subIdx}`}>
                            <th className="sales-bg" key={`subgroup-${idx}-${customerGroupIdx}-${subIdx}`}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'space-around' }}>
                                <span>{subgroup.name}</span>
                                {/* subgroup.is_deletable && handleDeleteColumnClick && checkDeletePermission(permissions, 'reserve') && (
                                  <Tooltip title="Delete this column">
                                    <button
                                      onClick={() => {
                                        const deleteIds = [group?.maiProductGroup?.[0]?.product_id];
                                        let refreshIds = group?.maiProductGroup?.[0]?.product_id;
                                        if (group?.prepackProductType == 0) {
                                          refreshIds = Object.keys(group.finishedProductCodes || {});
                                        } else if (group?.prepackProductType == 2) {
                                          refreshIds = [group?.maiProductGroup?.[0]?.product_id, ...Object.keys(group.finishedProductCodes || {})];
                                        }
                                        handleDeleteColumnClick({
                                          customer_group_id: subgroup.customer_group_id,
                                          customer_sub_group_id: subgroup.id,
                                          product_ids: deleteIds,
                                          refresh_product_ids: Array.isArray(refreshIds) ? refreshIds : [refreshIds],
                                          label: customerGroup.name,
                                          subgroup_name: subgroup.name,
                                        });
                                      }}
                                      style={{
                                        background: 'none', border: 'none', cursor: 'pointer',
                                        padding: '2px', color: '#dc3545', lineHeight: 1,
                                        display: 'inline-flex', alignItems: 'center',
                                      }}
                                      title="Delete column"
                                    >
                                      🗑
                                    </button>
                                  </Tooltip>
                                ) */}
                              </div>
                            </th>
                          </React.Fragment>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            );
          } else if (item.type === 'product') {
            const productGroup = item.data;
            return (
              <React.Fragment key={`product-row3-${idx}-${productGroup.productGroupOriginalId}`}>
                {!hiddenReserveGroups?.has(productGroup?.productGroupOriginalId) && productGroup.customerGroups.flatMap((customerGroup, customerIdx) => (
                  customerGroup.subGroups.map((subgroup, subIdx) => (
                    <th
                      className="sales-bg"
                      key={`subgroup-${idx}-${customerIdx}-${subIdx}`}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'space-around' }}>
                        <span>{subgroup.name}</span>
                        {/* subgroup.is_deletable && handleDeleteColumnClick && checkDeletePermission(permissions, 'reserve') && (
                          <Tooltip title="Delete this column">
                            <button
                              onClick={() => {
                                 const deleteIds = [productGroup.productGroupOriginalId];
                                 let refreshIds = [productGroup.productGroupOriginalId];
                                 if (productGroup?.prepackProductType == 1) {
                                   refreshIds = [productGroup.productGroupOriginalId];
                                 } else if (productGroup?.prepackProductType == 0) {
                                   refreshIds = Object.keys(productGroup.finishedProductCodes || {});
                                 } else if (productGroup?.prepackProductType == 2) {
                                   refreshIds = [productGroup.productGroupOriginalId, ...Object.keys(productGroup.finishedProductCodes || {})];
                                 }
                                 handleDeleteColumnClick({
                                   customer_group_id: subgroup.customer_group_id,
                                   customer_sub_group_id: subgroup.id,
                                   product_ids: deleteIds,
                                   refresh_product_ids: refreshIds,
                                   label: customerGroup.customerGroupName,
                                   subgroup_name: subgroup.name,
                                 });
                              }}
                              style={{
                                background: 'none', border: 'none', cursor: 'pointer',
                                padding: '2px', color: '#dc3545', lineHeight: 1,
                                display: 'inline-flex', alignItems: 'center',
                              }}
                              title="Delete column"
                            >
                              🗑
                            </button>
                          </Tooltip>
                        ) */}
                      </div>
                    </th>
                  ))
                ))}
              </React.Fragment>
            );
          }
          return null;
        })}
      </tr>

    </thead>
  );
};

const GenerateTable = ({ arrivalsData, dateState, currentPage, inoutData, setInoutData, addedColumns, setAddedColumns, setModalReserve, setReserveModalUpdateData, showGroupData, setshowGroupData, setSelectedGroupProducts, setArrivalModalData, tableRef, setShowAllArrivals, showAllArrivals, selectedGroupProducts, setArrivalModalShow, isEditing, updateId, updateDate, updateProduct, updateValue, setIsEditing, setUpdateValue, setUpdateId, setUpdateDate, setUpdateProduct, updateReserveData, arrivalModalShow, setSelectedArrivalProductId, setArrivalQuantityMap, arrivalModalData, selectedArrivalProductId, setSelectedArrivalProductData, setArrivalModalError, arrivalQuantityMap, arrivalModalError, arrivalModalLoading, handleSaveArrivalData, modalReserve, modalRef, setReserveModalError, reserveModalUpdateData, selectedProductId, setSelectedProductId, setQuantityValue, quantityValue, reserveModalError, toastMessage, setProductLabelModal, addColumnModal, setAddColumnModal, productLabelModal, setLabelData, labelData, setSubGroup, setSubGroupName, subGroup, subGroupName, setGroupName, groupName, setProductName, productName, setLabelDate, labelDate, loader, setProductGroupLabelModal, productGroupLabelModal, groupRef, firstRadioRefProductLabel, firstRadioArrivalRef, quatityRef, setGroupProductIds, labels, customerSubGroups, fetchLableCustomerGroups, labelCustomerGroups, getInOutDataForReserveUpdate, updateArrivalOrderRemarkOnDrop, selectedCellsForSum, setSelectedCellsForSum, inputValues, convertOutInputs, setConvertOutInputs, setModalConvertOut, modalConvertOut, debouncedUpdateConvertOutData, handleInlineAddReserve, handleInlineAddArrival,getArrivalsData }) => {
  // console.log('labelDAtalabvvfdfd',labelData);
  const [modalInputDisabled, setModalInputDisabled] = useState(false);
  const [hiddenReserveGroups, setHiddenReserveGroups] = useState(new Set());

  const toggleReserveGroup = (groupKey) => {
    setHiddenReserveGroups(prev => {
      const next = new Set(prev);
      if (next.has(groupKey)) {
        next.delete(groupKey);
      } else {
        next.add(groupKey);
      }
      return next;
    });
  };
  const { data: rolesData } = useSelector((state) => state.roleData);
  const [selectedCell, setSelectedCell] = useState({ row: null, col: null });

  // Cell Remark states
  const [contextMenu, setContextMenu] = useState(null);
  const [selectedCellData, setSelectedCellData] = useState(null);
  const [remarkModal, setRemarkModal] = useState({ show: false, mode: 'add', data: [] });
  const [cellRemarks, setCellRemarks] = useState([]);
  
  // History Modal states
  const [historyModal, setHistoryModal] = useState({ visible: false, rawProductId: null, finishedProductId: null, date: null });

  // Actual Stock Edit Modal states
  const [actualStockModal, setActualStockModal] = useState({ visible: false, actual_stock: '', date: '', product_id: '', refreshIds: null });
  const [actualStockLoading, setActualStockLoading] = useState(false);

  // Clone Arrival Modal — consolidated into one object
  const CLONE_INITIAL = {
    open: false, isLoading: false, arrival: null,
    formData: { supplier: '', shipping_method: '', order_remark: '', container_no: '', atd: '', ata: '', eta: '', status: 0, arrival_id: '' },
    errors: { supplier: '', shipping_method: '', order_remark: '', container_no: '', atd: '', ata: '', eta: '' },
    touched: { supplier: false, shipping_method: false, order_remark: false, container_no: false, atd: false, ata: false, eta: false },
    suppliers: [], shippingMethods: [], selectedProducts: [], productList: [], filterData: [], searchTerm: '',
  };
  const [cloneModal, setCloneModal] = useState(CLONE_INITIAL);
  const updateClone = (patch) => setCloneModal(prev => ({ ...prev, ...patch }));

  // Delete Arrival Modal — consolidated into one object
  const [deleteModal, setDeleteModal] = useState({ open: false, isLoading: false, cellData: null });

  // Delete Column confirmation modal state
  const [deleteColumnModal, setDeleteColumnModal] = useState({ open: false, isLoading: false, columnData: null });

  const handleDeleteColumnClick = (columnData) => {
    setDeleteColumnModal({ open: true, isLoading: false, columnData });
  };

  const confirmDeleteColumn = async () => {
    const { columnData } = deleteColumnModal;
    if (!columnData) return;
    setDeleteColumnModal(prev => ({ ...prev, isLoading: true }));
    try {
      const params = new URLSearchParams();
      params.append('customer_group_id', columnData.customer_group_id);
      params.append('customer_sub_group_id', columnData.customer_sub_group_id);
      params.append('from_date', dateState?.startDate);
      params.append('to_date', dateState?.endDate);
      (columnData.product_ids || []).forEach(id => params.append('product_ids[]', id));

      const response = await deleteApi(`/reserve/column?${params.toString()}`);
      if (response?.success) {
        toast.success(response.msg || 'Column deleted successfully');
        setDeleteColumnModal({ open: false, isLoading: false, columnData: null });
        await getInOutDataForReserveUpdate(columnData.refresh_product_ids || columnData.product_ids);
      } else {
        toast.error(response?.msg || 'Failed to delete column');
        setDeleteColumnModal(prev => ({ ...prev, isLoading: false }));
      }
    } catch (err) {
      toast.error(err.message || 'Failed to delete column');
      setDeleteColumnModal(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleCloneArrival = async () => {
    setContextMenu(null);
    if (!selectedCellData?.arrival_id_raw) return;

    try {
      updateClone({ isLoading: true });

      const canonicalTimezone = getCanonicalTimezone();
      const [suppliersResp, shippingResp, listResp] = await Promise.all([
        getApi('/suppliers?per_page=9999'),
        getApi('/shipping-method?per_page=999'),
        getApi(`/arrival-summary?page=1&per_page=1&sort_order=desc&sort_column=arrival_id&timezone=${canonicalTimezone}`),
      ]);

      const suppliers = suppliersResp?.success ? (suppliersResp.data?.suppliers?.data || []) : [];
      const shippingMethods = shippingResp?.success ? (shippingResp.data?.shippingMethods?.data || shippingResp.data?.shippingMethods || []) : [];
      let nextArrivalId = 1;
      if (listResp?.success) {
        const sorted = [...(listResp.data.arrivalSummaries?.data || [])].sort(
          (a, b) => Number(b.arrival_id) - Number(a.arrival_id)
        );
        nextArrivalId = sorted[0]?.arrival_id ? Number(sorted[0].arrival_id) + 1 : 1;
      }

      const arrivalResp = await getApi(`/arrival-summary/${selectedCellData.arrival_id_raw}`);
      if (arrivalResp?.success) {
        const arrival = arrivalResp.data?.arrivalSummary;
        const clonedProducts = (arrival?.products || []).map(p => ({ ...p, checked: true, quantity: '', barcode: '' }));
        setCloneModal({
          open: true, isLoading: false, arrival,
          formData: {
            supplier: arrival?.supplier_id || '',
            shipping_method: arrival?.shipping_method_id || '',
            order_remark: '',
            container_no: arrival?.container_no || '',
            atd: arrival?.atd || '',
            ata: arrival?.ata || '',
            eta: arrival?.eta || '',
            status: arrival?.status === true ? 1 : 0,
            arrival_id: nextArrivalId
          },
          errors: { supplier: '', shipping_method: '', order_remark: '', container_no: '', atd: '', ata: '', eta: '' },
          touched: { supplier: false, shipping_method: false, order_remark: false, container_no: false, atd: false, ata: false, eta: false },
          suppliers, shippingMethods, selectedProducts: clonedProducts, productList: clonedProducts, filterData: [],
        });
      } else {
        toast.error('Failed to load arrival data');
        updateClone({ isLoading: false });
      }
    } catch (error) {
      toast.error(error.message || 'Failed to load arrival data');
      updateClone({ isLoading: false });
    }
  };

  const handleCloneArrivalSave = async () => {
    const { formData, selectedProducts } = cloneModal;
    const requiredFields = ['supplier', 'shipping_method', 'eta'];
    let isValid = true;
    const newErrors = { ...cloneModal.errors };
    const newTouched = { ...cloneModal.touched };
    requiredFields.forEach(field => {
      newTouched[field] = true;
      if (!formData[field]) {
        newErrors[field] = `${field.replace('_', ' ')} is required`;
        isValid = false;
      }
    });
    updateClone({ errors: newErrors, touched: newTouched });
    if (!isValid) return;
    if (!selectedProducts?.length) { toast.error('Please add at least one product'); return; }
    const invalid = selectedProducts.filter(p => p.quantity === undefined || p.quantity === null || isNaN(p.quantity) || p.quantity === '');
    if (invalid.length > 0) { toast.error('Please fill quantity for all selected products'); return; }

    try {
      updateClone({ isLoading: true });
      const safeValue = (val) => (val === null || val === undefined ? '' : val);
      const payload = new FormData();
      payload.append('supplier_id', safeValue(formData.supplier));
      payload.append('shipping_method_id', safeValue(formData.shipping_method));
      payload.append('order_remark', safeValue(formData.order_remark));
      payload.append('container_no', safeValue(formData.container_no));
      payload.append('atd', safeValue(formData.atd));
      payload.append('ata', safeValue(formData.ata));
      payload.append('eta', safeValue(formData.eta));
      payload.append('status', safeValue(formData.status));
      payload.append('arrival_id', safeValue(formData.arrival_id));
      selectedProducts.forEach((product, index) => {
        payload.append(`products[${index}][id]`, safeValue(product?.id));
        payload.append(`products[${index}][quantity]`, product.quantity === '' ? 0 : Number(product.quantity));
        payload.append(`products[${index}][barcode]`, safeValue(product?.barcode) || 0);
      });
      const response = await postApi('/arrival-summary', payload);
      if (response?.success) {
        toast.success(response.msg || 'Arrival cloned successfully');
        setCloneModal(CLONE_INITIAL);
          const productIds = selectedProducts.map(p => p.id);
          // getInOutDataForReserveUpdate(productIds);
          getArrivalsData();
      } else {
        toast.error(response?.msg || 'Failed to clone arrival');
        updateClone({ isLoading: false });
      }
    } catch (error) {
      toast.error(error.message || 'Failed to clone arrival');
      updateClone({ isLoading: false });
    }
  };

  const handleDeleteArrival = () => {
    setContextMenu(null);
    if (!selectedCellData?.arrival_id_raw) return;
    setDeleteModal({ open: true, isLoading: false, cellData: selectedCellData });
  };

  const handleDeleteArrivalConfirm = async () => {
    if (!deleteModal.cellData?.arrival_id_raw) return;
    try {
      setDeleteModal(prev => ({ ...prev, isLoading: true }));
      const response = await deleteApi(`/arrival-summary/${deleteModal.cellData.arrival_id_raw}`);
      if (response?.success) {
        toast.success(response.msg || 'Arrival deleted successfully');
        setDeleteModal({ open: false, isLoading: false, cellData: null });
          // getInOutDataForReserveUpdate();
          getArrivalsData();
        // Manually sync UI state by filtering out the deleted arrival ID
        // if (deleteModal.cellData?.arrival_id_raw) {
        //   setInoutData(prev => {
        //     const updatedArrivalsData = { ...(prev.arrivals?.data || {}) };
        //     Object.keys(updatedArrivalsData).forEach(date => {
        //       updatedArrivalsData[date] = (updatedArrivalsData[date] || []).filter(
        //         item => item.id !== deleteModal.cellData.arrival_id_raw
        //       );
        //       // Clean up empty dates if necessary
        //       if (updatedArrivalsData[date].length === 0) {
        //         delete updatedArrivalsData[date];
        //       }
        //     });
        //     return {
        //       ...prev,
        //       arrivals: {
        //         ...prev.arrivals,
        //         data: updatedArrivalsData,
        //       },
        //     };
        //   });
        // }
      } else {
        toast.error(response?.msg || 'Failed to delete arrival');
        setDeleteModal(prev => ({ ...prev, isLoading: false }));
      }
    } catch (error) {
      toast.error(error.message || 'Failed to delete arrival');
      setDeleteModal(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleProductChange = (products) => {
    updateClone({ selectedProducts: products });
  };

  const removeProduct = (productId) => {
    const updated = cloneModal.selectedProducts.filter(p => p.id !== productId);
    updateClone({ selectedProducts: updated });
  };

  useEffect(() => {
    function handleClick(event) {
      const target = event.target
      // console.log('target', target.tagName);
      if (target.tagName === "SPAN") {
        setSelectedCell({ row: null, col: null });
      }

      // if click is outside table completely → also reset
      if (tableRef.current && !tableRef.current.contains(target)) {
        setSelectedCell({ row: null, col: null });
      }
    }

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);
  const inputRefs = useRef([]);
  const flatInputIndex = useRef(0);
  const [tooltipPosition, setTooltipPosition] = useState({
    visible: false,
    content: null,
    x: 0,
    y: 0,
    arrival: null,
    promotionType: null,
    unitPriceValue: null
  });
  const tooltipStyle = {
    position: 'fixed',
    top: `${tooltipPosition.y}px`,
    left: `${tooltipPosition.x}px`,
    backgroundColor: '#FDE6FA',
    padding: '10px',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    zIndex: 1000,
    display: tooltipPosition.visible ? 'block' : 'none',
    minWidth: '500px',
    maxWidth: '500px',
    // pointerEvents: 'none' // Allows clicking through the tooltip
  };
  const [prepackProductsForDropdown, setPrepackProductsForDropdown] = useState([]);
  const [allPrepackProductsForGroup, setAllPrepackProductsForGroup] = useState([]);
  const [selectedManualConvertOutPrepackProduct, setSelectedManualConvertOutPrepackProduct] = useState(null);
  const [selectedManualConvertOutRawProductId, setSelectedManualConvertOutRawProductId] = useState(null);
  const [selectedManualConvertOutFinishedProductId, setSelectedManualConvertOutFinishedProductId] = useState(null);
  const [selectedManualConvertOutDate, setSelectedManualConvertOutDate] = useState(null);
  const [selectedManualConvertOutQuantity, setSelectedManualConvertOutQuantity] = useState(null);
  const [selectedLabel, setSelectedLabel] = useState(null);
  const [selectedCustomerGroup, setSelectedCustomerGroup] = useState(null);
  const [selectedCustomerSubGroup, setSelectedCustomerSubGroup] = useState(null);
  const [addColumnProductId, setAddColumnProductId] = useState(null);
  const [addColumnProductGroupId, setAddColumnProductGroupId] = useState(null);
  const [existingcolumns, setExistingcolumns] = useState([]);
  const [rawProductOptions, setRawProductOptions] = useState([]);
  const [selectedRawProductForModal, setSelectedRawProductForModal] = useState(null);
  const [isFetchingQuantity, setIsFetchingQuantity] = useState(false);

  // Fetch all prepack products for the group's raw product IDs
  useEffect(() => {
    async function fetchAllPrepackProducts() {
      if (!selectedManualConvertOutRawProductId || !Array.isArray(selectedManualConvertOutRawProductId)) {
        setRawProductOptions([]);
        setAllPrepackProductsForGroup([]);
        return;
      }

      // Filter out empty values
      const rawProductIds = selectedManualConvertOutRawProductId.filter(id => id);

      if (rawProductIds.length === 0) {
        setRawProductOptions([]);
        setAllPrepackProductsForGroup([]);
        return;
      }

      const params = new URLSearchParams();
      params.append('search', '');
      params.append('page', 1);
      params.append('per_page', 9999);
      params.append('prepack_type', 'C');

      // Add all raw product IDs to the query
      rawProductIds.forEach(id => {
        params.append('raw_product_ids[]', id);
      });
      if(selectedManualConvertOutFinishedProductId){
        params.append('product_ids[]', selectedManualConvertOutFinishedProductId);
      }

      const resp = await getApi(`/prepack-product?${params.toString()}`);
      if (resp?.success === true) {
        const prepackProducts = resp?.data?.prepackProducts?.data || [];
        setAllPrepackProductsForGroup(prepackProducts);

        // Extract unique raw products
        const uniqueRawProducts = [];
        const seenIds = new Set();

        prepackProducts.forEach(item => {
          if (!seenIds.has(item.raw_product_id)) {
            seenIds.add(item.raw_product_id);
            uniqueRawProducts.push({
              id: item.raw_product_id,
              name: item.raw_product_name_tc,
              code: item.raw_product_code
            });
          }
        });

        setRawProductOptions(uniqueRawProducts);
      }

      // Reset selections when raw product IDs change
      setSelectedRawProductForModal(null);
      setSelectedManualConvertOutPrepackProduct(null);
    }

    fetchAllPrepackProducts();
  }, [selectedManualConvertOutRawProductId]);

  // Filter finished products when a raw product is selected
  useEffect(() => {
    if (!selectedRawProductForModal || allPrepackProductsForGroup.length === 0) {
      setPrepackProductsForDropdown([]);
      return;
    }

    // Filter finished products for the selected raw product
    const filteredProducts = allPrepackProductsForGroup.filter(
      item => item.raw_product_id === selectedRawProductForModal
    );

    const uniqueFilteredProducts = [...new Map(filteredProducts.map(item => [item?.finished_product_id, item])).values()];

    setPrepackProductsForDropdown(uniqueFilteredProducts);
  }, [selectedRawProductForModal, allPrepackProductsForGroup]);
  const handleLabelChange = (label) => {
    fetchLableCustomerGroups(label);
    setSelectedLabel(label);
    setSelectedCustomerGroup(null);
  }
  const handleCustomerGroupChange = (value) => {
    setSelectedCustomerGroup(value);
  };
  const handleCustomerSubGroupChange = (value) => {
    setSelectedCustomerSubGroup(value);
  };
  const resetAddColumnModalStates = () => {
    setAddColumnModal(false);
    setSelectedLabel(null);
    setSelectedCustomerGroup(null);
    setSelectedCustomerSubGroup(null);
    setGroupProductIds(null);
    setAddColumnProductId(null);
    setAddColumnProductGroupId(null);
  }
  const handleAddColumnClick = (productId, existingColumnsArray, productGroupId = null, prepackProductType = null, finishedProductCodes = {}) => {
    setAddColumnModal(true);
    setExistingcolumns(existingColumnsArray);
    setAddColumnProductId(productId);
    setAddColumnProductGroupId(productGroupId);

    if (productGroupId) {
      const groupProductIds = inoutData.sections?.data?.find(item => item.group_key === productGroupId)?.product_ids?.split(',') || [];
      let reserveUpdateProductIds = [];
      if (prepackProductType == 0) {
        reserveUpdateProductIds = [...Object.keys(finishedProductCodes || {})];
      } else if (prepackProductType == 1) {
        reserveUpdateProductIds = [...groupProductIds];
      } else if (prepackProductType == 2) {
        reserveUpdateProductIds = [...groupProductIds, ...Object.keys(finishedProductCodes || {})];
      } else {
        reserveUpdateProductIds = groupProductIds;
      }
      setGroupProductIds(reserveUpdateProductIds);
    } else {
      let reserveUpdateProductIds = productId;
      if (prepackProductType == 1) {
        reserveUpdateProductIds = productId;
      } else if (prepackProductType == 0) {
        reserveUpdateProductIds = Object.keys(finishedProductCodes || {});
      } else if (prepackProductType == 2) {
        reserveUpdateProductIds = [productId, ...Object.keys(finishedProductCodes || {})];
      }
      setGroupProductIds(reserveUpdateProductIds);
    }
  };
  const [isAddingColumn, setIsAddingColumn] = useState(false);

  const handleColumnAdd = async () => {
    if (!selectedLabel || !selectedCustomerGroup || !selectedCustomerSubGroup) {
      toast.error('Please select all fields');
      return;
    }

    if (
      existingcolumns.some(
        col =>
          (col.customerGroupName || col.name) === selectedLabel &&
          col.subGroups?.some(sg => sg.id === selectedCustomerSubGroup)
      )
    ) {
      toast.error('Column already exists');
      return;
    }

    setIsAddingColumn(true);
    try {
      /*
      const urlEncodedData = new URLSearchParams();
      urlEncodedData.append('customer_group_id', selectedCustomerGroup);
      urlEncodedData.append('customer_sub_group_id', selectedCustomerSubGroup);
      urlEncodedData.append(
        'product_id', addColumnProductId
      );
      const currentDate = new Date(dateState?.startDate);
      const nextDateObj = addDays(currentDate, 1);
      const formattedNextDate = format(nextDateObj, 'yyyy-MM-dd');

      urlEncodedData.append(`dates[0][date]`, formattedNextDate);
      urlEncodedData.append(`dates[0][quantity]`, '0');
      urlEncodedData.append(`dates[0][promotion_type]`, '');
      // Mark as system-created placeholder so it can be safely deleted later
      urlEncodedData.append('source_flag', '1');


      const response = await postApi('/reserve', urlEncodedData.toString());
      if (response.success) {
        await getInOutDataForReserveUpdate();
        resetAddColumnModalStates();
        toast.success('Added Successfully');
        // relaod pink section
      } else {
        toast.error(response.msg);

      }
      */

      const targetType = addColumnProductGroupId ? 'productGroup' : 'product';
      const targetKey = addColumnProductGroupId || addColumnProductId;

      const subGroupObj = customerSubGroups?.find(sg => sg.id === selectedCustomerSubGroup);
      const groupObj = labelCustomerGroups?.find(g => g.group_id === selectedCustomerGroup);

      const newCol = {
        targetType,
        targetKey,
        selectedLabel,
        selectedCustomerGroup,
        selectedCustomerSubGroup,
        subGroupName: subGroupObj?.name || "",
        groupCode: groupObj?.code || "",
        groupName: groupObj?.name || selectedLabel,
        addColumnProductId,
        addColumnProductGroupId
      };

      setAddedColumns(prev => [...(prev || []), newCol]);

      resetAddColumnModalStates();
      toast.success('Added Successfully');
    } catch (err) {
      console.error(err);
      toast.error("Save failed, please try again.");
    } finally {
      setIsAddingColumn(false);
    }
  };

  let hideTooltipTimeout;

  const itemsPerPage = 150;
  const fromDate = new Date(dateState?.startDate);
  const toDate = new Date(dateState?.endDate);
  // const dateRange = eachDayOfInterval({ start: fromDate, end: toDate });
  const allDates = eachDayOfInterval({ start: fromDate, end: toDate });

  // Calculate paginated dates
  const totalPages = Math.ceil(allDates.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const dateRange = allDates.slice(startIndex, endIndex);
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // Find maximum number of arrivals
  let maxArrivalsCount = 0;
  Object.values(inoutData?.arrivals?.data || {}).forEach(dateArrivals => {
    if (dateArrivals.length > maxArrivalsCount) {
      maxArrivalsCount = dateArrivals.length;
    }
  });
  const groupMap = {};
  // const salesColumns = [];

  const handleModalReserve = (data) => {
    // setModalReserve(true)
    setReserveModalUpdateData(data)
  }

  // const handleModalReserveGroup = (data) => {
  //   // setModalReserve(true)
  //   setReserveModalUpdateData(data)
  // }

  const salesColumns = transformData(inoutData);
  let salesColumnsWithData = [];

  try {

    salesColumnsWithData = []
    const productGroupHeadings = inoutData?.sectionArrivals?.productGroup?.heading || {};
    const inventoryGroups = inoutData?.inventories?.productGroup || {};
    const productGroupData = inoutData?.sectionArrivals?.productGroup?.data || {};
    const productGroupHistory = inoutData?.sectionArrivals?.productGroup?.history || {};

    // Combine all unique group IDs from all sources
    const allGroupIds = [
      ...new Set([
        ...Object.keys(productGroupHeadings),
        ...Object.keys(inventoryGroups),
        ...Object.keys(productGroupData),
        ...Object.keys(productGroupHistory)
      ])
    ];

    // Process each group
    allGroupIds.forEach(groupId => {
      // Skip if group already exists in salesColumns
      const groupExists = salesColumns.filter(col =>
        col.productGroupkey === groupId
      );
      if (groupExists?.length <= 0) return;

      // Get group info from the most authoritative source
      const groupInfo = productGroupHeadings[groupId] || {
        id: groupId,
        group_no: groupId,
        customerGroups: {}
      };

      // Process customer group structure
      const customerGroups = groupInfo.customerGroups || {};
      const groupNames = Object.values(customerGroups).map(cg => ({
        name: cg.label,
        subGroups: Object.values(cg.subGroup || {}).map(sg => ({
          id: sg.id,
          name: sg.name
        }))
      }));

      const colSpan = groupNames.reduce((sum, group) => sum + (group.subGroups?.length || 0), 0);

      const groupData = productGroupData[groupId] || {};
      const groupHistory = productGroupHistory[groupId] || {};
      const inventoryData = inventoryGroups[groupId] || {};

      const transformedData = {};
      const transformedHistory = {};
      // const transformedInventory = {};
      const transformedInventory = {
        products: (inventoryData?.products || []).map(product => ({
          ...product,
          groupId,
        })),
        data: Object.entries(inventoryData?.dates || {}).map(([date, value]) => ({
          date,
          ...value,
          groupId,
        })),
        // data:(() => {
        //   const dateEntry = inventoryData?.dates?.[formattedDate];
        //   if (!dateEntry) return [];
        //   return [{
        //     date: formattedDate,
        //     ...dateEntry,
        //     groupId,
        //   }];
        // })(),
      };

      Object.entries(groupData).forEach(([date, items]) => {
        if (!Array.isArray(items)) return;
        if (!transformedData[date]) transformedData[date] = [];

        transformedData[date].push(
          ...items.map(item => ({
            ...item,
            arrival: item.quantity
          }))
        );
      });

      Object.entries(groupHistory).forEach(([productGroupId, dates]) => {
        Object.entries(dates || {}).forEach(([date, historyItems]) => {
          if (!Array.isArray(historyItems)) return;

          if (!transformedHistory[date]) transformedHistory[date] = [];

          transformedHistory[date].push(...historyItems);
        });
      });


      // Process inventory data (date → inventory info)
      // Object.entries(inventoryData).forEach(([date, inventory]) => {
      //   transformedInventory.data[date] = {
      //     estimated: inventory?.estimated,
      //     actual: inventory?.actual,
      //     status: inventory?.status,
      //     total: inventory?.total,
      //     products: (inventory?.products || []).map(p => ({
      //       ...p,
      //       groupId // Include group reference
      //     }))
      //   };
      // });
      // Add to salesColumnsWithData
      salesColumnsWithData.push({
        productGroupId: groupExists[0].productGroupId || groupId,
        productGroupKey: groupExists[0].productGroupkey,
        groupName: groupInfo.name || `Group ${groupId}`,
        groupNames,
        colSpan,
        arrivalData: transformedData,
        arrivalHistory: transformedHistory,
        inventoryData: transformedInventory,

      });
    });

    // Final validation
    salesColumnsWithData = salesColumnsWithData.filter(Boolean);


  } catch (error) {
    console.error("Error processing sales columns:", error);
    // salesColumnsWithData = salesColumns;
  }



  const productGroupStructure = {};
  const productSalesHeaders = [];
  const orderArrivalData = inoutData?.productOrderArrivals;

  const headings = inoutData?.sections?.data || [];
  //processing products data
  const allHeadings = Object.values(headings)
    .filter(heading => !heading.product_group_id) //only products not  group
    .map(heading => {
      const reserveData = inoutData?.sectionReserves?.product?.heading[heading.product_ids]; //it is only one id as it is case of products

      return reserveData ? { ...heading, ...reserveData } : heading;
    });

  // Helper function to create combined ordered columns
  const createCombinedOrderedColumns = (sectionsData, salesCols, productSalesHeaders) => {
    const combined = [];
    const sectionsArray = Object.values(sectionsData || []);

    sectionsArray.forEach(section => {
      if (section.product_group_id) {
        // It's a group - find matching salesColumn
        const matchingGroup = salesCols.find(col =>
          col.productGroupkey === section.group_key
        );
        if (matchingGroup) {
          combined.push({
            type: 'group',
            data: matchingGroup
          });
        }
      } else if (section.product_ids) {
        // It's a product - find matching productSalesHeader
        const matchingProduct = productSalesHeaders.find(header =>
          header.productGroupOriginalId === section.product_ids
        );
        if (matchingProduct) {
          combined.push({
            type: 'product',
            data: matchingProduct
          });
        }
      }
    });

    return combined;
  };



  try {

    allHeadings.forEach(product => {
      // [  {customerGroups:{},
      //       id: 
      //       name_tc
      //       product_code
      //       group_key 
      //       group_no 
      //       prepack_product_type 
      //       product_code 
      //       product_group_id 
      //       product_ids 
      //       product_name_tc },...]
      const productId = product.product_ids;
      const productName = product.product_name_tc;
      const productCode = product.product_code;
      const prepackProductType = product.prepack_product_type; //0:raw, 1:finished, 2:both

      if (!productGroupStructure[productId]) {
        productGroupStructure[productId] = {
          groupName: productName,
          productGroupName: productName,
          productCode: productCode,
          customerGroups: {},
          prepackProductType: prepackProductType,
          finishedProductCodes: product.finished_product_codes,
          finishedProductNames: product.finished_product_names,
          finishedProductConvertRatios: product.finished_product_convert_ratios,
          finishedProductSpecialPeriods: product.finished_product_special_periods,
          prepackTypes: product.prepack_types,
          paCode: product?.pa_code,
          barcode: product?.barcode,
        };
      }

      Object.values(product.customerGroups || {}).forEach(customerGroup => {
        const customerGroupId = customerGroup.id;
        if (!customerGroupId) return;

        if (!productGroupStructure[productId].customerGroups[customerGroupId]) {
          productGroupStructure[productId].customerGroups[customerGroupId] = {
            name: customerGroup.label,
            subGroups: []
          };
        }

        Object.values(customerGroup.subGroup || {}).forEach(subGroup => {
          productGroupStructure[productId].customerGroups[customerGroupId].subGroups.push({
            id: subGroup.id,
            name: subGroup.name,
            customer_group_id: subGroup.customer_group_id,
            is_deletable: !!subGroup.is_deletable
          });
        });
      });
    });

    // Step 2: Build productSalesHeaders with inventory and arrival data
    Object.entries(productGroupStructure).forEach(([productId, groupData]) => {
      const customerGroups = [];
      let totalColSpan = 0;
      const mainOrderArrivalData = orderArrivalData[productId] || {};


      Object.values(groupData.customerGroups).forEach(customerGroup => {
        const uniqueSubGroups = Array.from(
          new Map(customerGroup.subGroups.map(sg => [sg.id, sg])).values()
        );

        customerGroups.push({
          customerGroupName: customerGroup.name, //label name
          subGroups: uniqueSubGroups,
          subGroupColSpan: uniqueSubGroups.length
        });

        if (!hiddenReserveGroups?.has(productId)) {
          totalColSpan += uniqueSubGroups.length;
        }
      });

      // Fetch groupArrivals and inventories data
      const groupArrivalsData = inoutData?.sectionArrivals?.product?.data?.[productId] || {};
      const groupHistoryData = inoutData?.sectionArrivals?.product?.history?.[productId] || {};
      const inventoryData = inoutData?.inventories?.product?.[productId] || {};

      // Transform arrival data
      const arrivalData = {};
      Object.entries(groupArrivalsData).forEach(([date, items]) => {
        if (!arrivalData[date]) arrivalData[date] = [];
        arrivalData[date].push(
          ...items.map(item => ({
            ...item,
            arrival: item.quantity
          }))
        );
      });


      // Transform history data
      const arrivalHistory = {};
      Object.entries(groupHistoryData).forEach(([date, history]) => {
        if (!arrivalHistory[date]) arrivalHistory[date] = {};
        arrivalHistory[date] = {
          ...arrivalHistory[date],
          ...history
        };
      });

      // Transform inventory data
      // const transformedInventory = {};
      // Object.entries(inventoryData).forEach(([date, inventory]) => {
      //   transformedInventory[date] = {
      //     estimated: inventory.estimated,
      //     actual: inventory.actual,
      //     status: inventory.status,
      //     total: inventory.total,
      //     products: inventory.products || []
      //   };
      // });
      const transformedInventory = {
        products: (inventoryData?.products || []).map(product => ({
          ...product,
          productId,
        })),
        data: Object.entries(inventoryData?.dates || {}).map(([date, value]) => ({
          date,
          ...value,
          productId,
        })),
      };
      if (typeof groupData.finishedProductCodes == 'object') {
        totalColSpan += Object.keys(groupData.finishedProductCodes).length;
      }

      if (groupData.prepackProductType == 1 || groupData.prepackProductType == 2) {
        totalColSpan++; //for convert in column
      }

      productSalesHeaders.push({
        productGroupId: groupData.productGroupName,
        productGroupOriginalId: productId,
        customerGroups,
        totalColSpan,
        arrivalData,
        arrivalHistory,
        inventoryData: transformedInventory,
        orderArrivalData: mainOrderArrivalData,
        productCode: groupData?.productCode,
        prepackProductType: groupData?.prepackProductType,
        finishedProductCodes: groupData?.finishedProductCodes,
        finishedProductNames: groupData?.finishedProductNames,
        finishedProductConvertRatios: groupData?.finishedProductConvertRatios,
        finishedProductSpecialPeriods: groupData?.finishedProductSpecialPeriods,
        prepackTypes: groupData?.prepackTypes,
        paCode: groupData?.paCode,
        barcode: groupData?.barcode,
      });
    });

  } catch (error) {
    console.error("Error processing product group sales headers:", error);
  }

  // Create combined ordered columns based on inoutData.sections.data order
  const combinedOrderedColumns = createCombinedOrderedColumns(headings, salesColumns, productSalesHeaders);

  let stockData = inoutData?.inventoryGrouping || {};
  const getInventoryProduct = () => {
    const productsById = {};

    if (!Array.isArray(productSalesHeaders)) {
      return { hasInventoryGroup: false, productsByGroupId: {} };
    }

    for (const productGroup of productSalesHeaders) {
      const groupId = productGroup.productGroupOriginalId;

      if (!groupId || !productGroup?.inventoryData) continue;
      for (const [date, dateData] of Object.entries(productGroup.inventoryData)) {
        if (Array.isArray(dateData?.products) && dateData.products.length > 0) {
          if (!productsById[groupId]) {
            productsById[groupId] = {};
          }

          if (!productsById[groupId][date]) {
            productsById[groupId][date] = [];
          }

          productsById[groupId][date].push(...dateData.products);
        }
      }
    }
    return {
      hasInventoryProduct: Object.keys(productsById).length > 0,
      productsById
    };
  };
  const { hasInventoryProduct, productsById } = getInventoryProduct();
  const getInventoryProductGroups = () => {
    const productsByGroupId = []; // Array instead of object
    if (!Array.isArray(salesColumnsWithData)) {
      return { hasInventoryGroup: false, productsByGroupId: [] };
    }
    for (const productGroup of salesColumnsWithData) {
      const groupId = productGroup.productGroupKey;

      if (!groupId || !productGroup?.inventoryData) continue;

      const products = {
        products: [],
        data: []
      };

      // for (const dateData of Object.values(productGroup.inventoryData)) {
      //   if (Array.isArray(dateData?.products)) {
      //     products.push(...dateData.products);
      //   }
      // }
      const inventoryData = productGroup?.inventoryData;
      if (inventoryData && typeof inventoryData === 'object') {
        // Add top-level products
        if (Array.isArray(inventoryData.products)) {
          products?.products.push(...inventoryData.products);
        }
        // Add products or data inside each date entry
        // if (inventoryData.dates && typeof inventoryData.data === 'object') {
        //   for (const dateKey in inventoryData.data) {
        //     const dateData = inventoryData.data[dateKey];

        //     if (dateData && typeof dateData === 'object') {
        //       if (Array.isArray(dateData.products)) {
        //         products.data.push(...dateData.products);
        //       }
        //       if (Array.isArray(dateData.data)) {
        //         products.data.push(...dateData.data);
        //       }
        //     }
        //   }
        // }
        if (Array.isArray(inventoryData) || (inventoryData.data && Array.isArray(inventoryData.data))) {
          const dateArray = Array.isArray(inventoryData)
            ? inventoryData
            : inventoryData.data;

          const productsList = [];

          for (const dateEntry of dateArray) {
            if (dateEntry.products && typeof dateEntry.products === 'object') {
              const date = dateEntry.date; // assuming it's a string like "2023-01-01"
              for (const [key, product] of Object.entries(dateEntry.products)) {
                productsList.push({
                  key,       // product key, e.g. "2023/0001"
                  date,      // date from parent entry
                  ...product // product details
                });
              }
            }
          }

          // If you want to dedupe or sort productsList, you can do it here
          products.data.push(...productsList);
        }

      }
      if (products.products.length > 0) {
        productsByGroupId.push({
          groupId,
          products,
          // Optional: Add other group metadata
          name: productGroup.name,
        });
      }
    }

    return {
      hasInventoryGroup: productsByGroupId.length > 0,
      productsByGroupId, // Now returns an array
    };
  };

  const { hasInventoryGroup, productsByGroupId } = getInventoryProductGroups();

  useEffect(() => {
    if (showGroupData && productsByGroupId) {
      const currentGroup = productsByGroupId.find(g => g.groupId === showGroupData);
      if (currentGroup) {
        setSelectedGroupProducts(prev => ({
          ...prev,
          [showGroupData]: currentGroup
        }));
      }
    }
  }, [inoutData, showGroupData]);


  const handleGroupToggle = (groupId, type) => {
    if (showGroupData === groupId) {
      setshowGroupData(null);
      setSelectedGroupProducts([]);
    } else {
      setshowGroupData(groupId);
      // setSelectedGroupProducts(productsByGroupId[groupId] || []);
      if (type === 'group') {
        setSelectedGroupProducts(prev => {
          // const group = productsByGroupId.find(g => g.groupId === groupId);
          const groupList = Array.isArray(productsByGroupId) ? productsByGroupId : [];
          const group = groupList.find(g => g.groupId === groupId);
          return {
            ...prev,
            [groupId]: group ? group : []
          };
        });

      } else {
        setSelectedGroupProducts(prev => ({
          ...prev,
          [groupId]: productsById[groupId] || []
        }));
      }
    }
  };

  const handleDateChange = (e) => {
    const newEta = e.target.value;

    setArrivalModalData((prevData) => ({
      ...prevData,
      eta: newEta
    }));
  };

  const isDeepEmpty = (obj) => {
    if (Array.isArray(obj)) return obj.length === 0;

    if (typeof obj === 'object' && obj !== null) {
      return Object.values(obj).every(value => isDeepEmpty(value));
    }

    return false; // primitive value or non-empty
  };

  const [fallbackProducts, setFallbackProducts] = useState({});
  const handleGetMainProduct = async (productGroupId) => {
    if (!productGroupId || fallbackProducts[productGroupId]) return;

    const resp = await getApi(`/product-group/${productGroupId}`);
    if (resp?.success === true) {
      const mainProduct = resp?.data?.productGroup?.products.find(product => product.is_main_product === 1);
      if (mainProduct) {
        setFallbackProducts(prev => ({
          ...prev,
          [productGroupId]: mainProduct
        }));
      } else {
        toast.error('No main product found');
      }
    }
  };

  const handleUpdateActualStock = async () => {
    try {
      setActualStockLoading(true);
      const urlEncodedData = new URLSearchParams();
      urlEncodedData.append('actual_stock', actualStockModal.actual_stock);
      urlEncodedData.append('date', actualStockModal.date);
      urlEncodedData.append('product_id', actualStockModal.product_id);
      const response = await postApi(`/inventory`, urlEncodedData.toString(), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });
      if (response?.success) {
        toast.success(response.msg || 'Inventory updated successfully');
        setActualStockModal({ visible: false, actual_stock: '', date: '', product_id: '', refreshIds: null });
        if (actualStockModal.refreshIds) {
          setGroupProductIds(actualStockModal.refreshIds);
          getInOutDataForReserveUpdate && getInOutDataForReserveUpdate(actualStockModal.refreshIds);
        } else {
          getInOutDataForReserveUpdate && getInOutDataForReserveUpdate();
        }
      } else {
        toast.error(response?.msg || 'Failed to update Inventory');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.msg || error.message || 'Failed to update Inventory';
      toast.error(errorMsg);
    } finally {
      setActualStockLoading(false);
    }
  };

  const onEditActualStock = (data) => {
    setActualStockModal({ visible: true, actual_stock: data.actual_stock, date: data.date, product_id: data.product_id, refreshIds: data.refreshIds });
  };

  // Fetch cell remarks for the date range
  useEffect(() => {
    const fetchCellRemarks = async () => {
      if (!dateState?.startDate || !dateState?.endDate) return;

      try {
        const params = new URLSearchParams();
        params.append('from_date', dateState.startDate);
        params.append('to_date', dateState.endDate);
        params.append('module', 'prepack-inout');

        const response = await getApi(`/cell-remark?${params.toString()}`);

        if (response.success) {
          setCellRemarks(response.data.remarks || []);
        }
      } catch (error) {
        console.error('Error fetching cell remarks:', error);
      }
    };

    fetchCellRemarks();
  }, [dateState]);

  // Build cell key for remark lookup
  // Helper function to get remarks for a specific cell
  const getCellRemarksArray = (cellData) => {
    if (!cellRemarks || !Array.isArray(cellRemarks)) return [];

    return cellRemarks.filter(remark => {
      return (
        remark.cell_type === cellData.cell_type &&
        remark.date === cellData.date &&
        remark.module === cellData.module &&
        remark.product_id === cellData.product_id &&
        remark.product_group_id === cellData.product_group_id &&
        remark.customer_group_id === cellData.customer_group_id &&
        remark.customer_sub_group_id === cellData.customer_sub_group_id &&
        remark.reserve_label === cellData.reserve_label &&
        remark.finished_product_id === cellData.finished_product_id &&
        remark.raw_product_id === cellData.raw_product_id &&
        remark.arrival_index === cellData.arrival_index
      );
    });
  };

  // Cell Remark functions
  const handleAddRemark = () => {
    setContextMenu(null);
    setRemarkModal({ show: true, mode: 'add', data: [] });
  };

  const handleViewRemarks = async () => {
    setContextMenu(null);
    if (!selectedCellData) return;

    const remarks = getCellRemarksArray(selectedCellData);

    setRemarkModal({
      show: true,
      mode: 'view',
      data: remarks
    });
  };

  const handleViewHistories = () => {
    setContextMenu(null);
    if (!selectedCellData) return;
    
    // Only show histories for convert_out cells
    const rawProductId = selectedCellData.raw_product_ids || selectedCellData.raw_product_id;
    if (selectedCellData.cell_type === 'convert_out' && rawProductId && selectedCellData.finished_product_id) {
      setHistoryModal({
        visible: true,
        rawProductId: rawProductId,
        finishedProductId: selectedCellData.finished_product_id,
        date: selectedCellData.date,
      });
    }
  };

  const handleRemarkAdded = async () => {
    setRemarkModal({ show: false, mode: 'add', data: [] });
    setSelectedCellData(null);

    // Refresh remarks
    if (dateState?.startDate && dateState?.endDate) {
      try {
        const params = new URLSearchParams();
        params.append('from_date', dateState.startDate);
        params.append('to_date', dateState.endDate);
        params.append('module', 'prepack-inout');

        const response = await getApi(`/cell-remark?${params.toString()}`);

        if (response.success) {
          setCellRemarks(response.data.remarks || []);
        }
      } catch (error) {
        console.error('Error fetching cell remarks:', error);
      }
    }
  };

  const getCellRemarkCount = (cellData) => {
    return getCellRemarksArray(cellData).length;
  };


  return (
    <>
      <table className={`table table-bordered align-middle ${isDeepEmpty(inoutData) ? 'no-table-data' : ''}`} id='directInoutTable' ref={tableRef}>
        <TableHeader
          maxArrivalsCount={maxArrivalsCount}
          showAllArrivals={showAllArrivals}
          setShowAllArrivals={setShowAllArrivals}
          salesColumns={salesColumns}
          salesColumnsWithData={salesColumnsWithData}
          showGroupData={showGroupData}
          selectedGroupProducts={selectedGroupProducts}
          productsByGroupId={productsByGroupId}
          productSalesHeaders={productSalesHeaders}
          // productsById={productsById}
          handleGroupToggle={handleGroupToggle}
          handleAddColumnClick={handleAddColumnClick}
          combinedOrderedColumns={combinedOrderedColumns}
          handleInlineAddReserve={handleInlineAddReserve}
          handleInlineAddArrival={handleInlineAddArrival}
          permissions={rolesData?.permissions}
          hiddenReserveGroups={hiddenReserveGroups}
          toggleReserveGroup={toggleReserveGroup}
          handleDeleteColumnClick={handleDeleteColumnClick}
        />
        <tbody>
          {dateRange.map((date, rowIndex) => {
            const formattedDate = format(date, 'yyyy-MM-dd');
            const shiftedDate = addDays(date, 1);
            const dayOfWeek = weekdays[getDay(shiftedDate)];
            const nextDate = format(shiftedDate, 'yyyy-MM-dd')
            const dateArrivals = inoutData?.arrivals?.data?.[formattedDate] || [];

            let columnCounter = { value: 0 };
            return (
              //all data rows after after heading rows
              <tr key={date}>
                {/* //ETA */}
                {(() => {
                  const thisCol = columnCounter.value++; return (
                    <td onClick={() => setSelectedCell({ row: rowIndex, col: thisCol })} className={`sticky-col ${isToday(shiftedDate) ? 'delivery-today' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}>{formattedDate}</td>
                  );
                })()}
                {/* //Delivery Date */}
                {(() => {
                  const thisCol = columnCounter.value++; return (
                    <td onClick={() => setSelectedCell({ row: rowIndex, col: thisCol })} className={`arrival-bg sticky-col ${isToday(shiftedDate) ? 'delivery-today' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}>{format(shiftedDate, 'yyyy-MM-dd')}</td>
                  );
                })()}
                {/* //Day */}
                {(() => {
                  const thisCol = columnCounter.value++; return (
                    <td
                      onClick={() => setSelectedCell({ row: rowIndex, col: thisCol })}
                      className={`sales-bg sticky-col ${maxArrivalsCount <= 0 ? 'not-arrival-qty' : ''} ${isToday(shiftedDate) ? 'delivery-today' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
                      style={maxArrivalsCount <= 0 ? { borderRight: '1px solid #000' } : undefined}
                    >
                      {dayOfWeek}
                    </td>
                  );
                })()}

                {/* //Arrival Info */}
                {maxArrivalsCount > 0 && (showAllArrivals ? Array.from({ length: maxArrivalsCount }) : [0]).map((_, idx) => {

                  return (
                    (() => {
                      const thisCol = columnCounter.value++;
                      let finishedProductId = '';
                      let arrivalProductIds = [];
                      if(dateArrivals[idx] && dateArrivals[idx].products && dateArrivals[idx].products.length > 0){
                         arrivalProductIds = dateArrivals[idx]?.products.map((product) => product.id);
                        
                      }
                      // else{
                      //   //arrival info remark in empty cell handle //now not allowing
                      //   const firstArrivalKey = Object.keys(inoutData?.arrivals?.data || {})[0];
                      //   arrivalProductIds = firstArrivalKey && inoutData.arrivals.data[firstArrivalKey]?.[0]?.products?.length > 0
                      //     ? inoutData.arrivals.data[firstArrivalKey]?.[0]?.products.map((product) => product.id)
                      //     : [];
                      // }
                      const matchedSection = inoutData.sections.data.find((section) =>
                        arrivalProductIds.some(id => section.product_ids.includes(id))
                      );
                      finishedProductId = matchedSection ? Object.keys(matchedSection.finished_product_codes)[0] : '';
                      
                      const cellData = buildCellData({
                        cellType: 'arrival_info',
                        date: formattedDate,
                        module: 'prepack-inout',
                        // arrivalIndex: idx,
                        productName: dateArrivals[idx]?.supplier_name_en || 'Arrival',
                        finishedProductId: finishedProductId,
                        arrival_id_raw: dateArrivals[idx]?.id,
                        product_ids: dateArrivals[idx]?.products?.map(p => p.id) || [],
                      });
                      const hasRemarks = cellHasRemarks(cellData, cellRemarks);

                      return (
                        <td
                          className={`arrival-bg fw-bold arival-info remark-enabled-cell ${hasRemarks ? 'cell-with-remark' : ''} ${maxArrivalsCount === (idx + 1) ? 'last_arrival_info' : `${showAllArrivals ? '' : 'last_arrival_info'}`} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
                          key={idx}
                          tabIndex={0}
                          {...getCellDataAttributes(cellData)}
                          onFocus={() => setSelectedCell({ row: rowIndex, col: thisCol })}
                          onClick={() => {
                            // setSelectedCell({ row: rowIndex, col: thisCol });
                            if (dateArrivals[idx]?.id) {
                              setArrivalModalShow(true);
                              setArrivalModalData({
                                ...dateArrivals[idx],
                                products: Array.isArray(dateArrivals[idx]?.products) ? dateArrivals[idx].products : []
                              });
                            }
                          }}
                          onContextMenu={(e) => {
                            if (dateArrivals[idx]?.id) {
                             handleCellContextMenu(e, cellData, setContextMenu, setSelectedCellData);
                            }
                          }}
                          onMouseEnter={(e) => {
                            if (dateArrivals[idx]?.id) {
                              clearTimeout(hideTooltipTimeout);
                              const rect = e.target.getBoundingClientRect();
                              setTooltipPosition({
                                visible: true,
                                content: dateArrivals[idx],
                                x: rect.right + 10,
                                y: rect.top,
                                arrival: dateArrivals[idx]
                              });
                            }
                          }}
                          onMouseLeave={() => {
                            // setTooltipPosition(prev => ({ ...prev, visible: false }));
                            hideTooltipTimeout = setTimeout(() => {
                              setTooltipPosition(prev => ({ ...prev, visible: false }));
                            }, 200);
                          }}
                          style={{
                            left: `${158 + ((idx + 1) * 79)}px`,
                            position: 'sticky',
                            width: '5%',
                            zIndex: 900,
                            cursor: dateArrivals[idx]?.id ? 'pointer' : 'default'
                          }}

                          draggable={!!dateArrivals[idx]?.order_remark} // only allow drag if remark exists
                          onDragStart={(e) => {
                            e.dataTransfer.setData("text/plain", JSON.stringify({
                              data: dateArrivals[idx],
                              sourceRowIndex: rowIndex

                            }
                            ));
                          }}
                          onDragOver={(e) => e.preventDefault()} // allow dropping
                          onDrop={(e) => {
                            e.preventDefault();
                            const droppedData = JSON.parse(e.dataTransfer.getData("text/plain"));

                            
                            updateArrivalOrderRemarkOnDrop(droppedData, formattedDate);

                          }}
                        >
                          <p className="inout-tab myDIV">
                            {/* {history !== undefined && history + ' -> '}{dateArrivals[idx] ? dateArrivals[idx].total_quantity : ''} */}
                            {dateArrivals[idx] !== undefined ? dateArrivals[idx].order_remark : ''}
                          </p>
                        </td>
                      );
                    })()
                  )
                })}

                {/* Combined ordered columns - groups and products in original order */}
                {combinedOrderedColumns.map((item, idx) => {
                  if (item.type === 'group') {
                    // Render product group cells
                    // const productGroupkey = item.data.productGroupkey;
                    // const customerGroups = inoutData?.sectionReserves?.productGroup?.data?.[productGroupkey] || {};

                    return renderPrepackProductGroupSection(
                      item,
                      salesColumnsWithData,
                      formattedDate,
                      inoutData,
                      isEditing,
                      updateId,
                      updateDate,
                      updateProduct,
                      updateValue,
                      setIsEditing,
                      setUpdateValue,
                      setUpdateId,
                      setUpdateDate,
                      setUpdateProduct,
                      updateReserveData,
                      showGroupData,
                      selectedGroupProducts,
                      setTooltipPosition,
                      nextDate,
                      setLabelData,
                      setSubGroup,
                      setProductName,
                      setLabelDate,
                      setProductGroupLabelModal,
                      setReserveModalUpdateData,
                      inputRefs,
                      flatInputIndex,
                      loader,
                      setGroupProductIds,
                      setModalInputDisabled,
                      setSubGroupName,
                      rolesData,
                      rowIndex,
                      columnCounter,
                      selectedCell,
                      setSelectedCell,
                      selectedCellsForSum,
                      setSelectedCellsForSum,
                      inputValues,
                      setModalConvertOut,
                      setSelectedManualConvertOutRawProductId,
                      setSelectedManualConvertOutFinishedProductId,
                      setSelectedManualConvertOutDate,
                      checkEditPermission,
                      setContextMenu,
                      setSelectedCellData,
                      cellRemarks,
                      onEditActualStock,
                      hiddenReserveGroups
                    );
                  } else if (item.type === 'product') {
                    // Render product cells
                    return renderPrepackProductData(
                      nextDate,
                      item.data,
                      inoutData,
                      isEditing,
                      updateId,
                      updateDate,
                      updateProduct,
                      updateValue,
                      setIsEditing,
                      setUpdateValue,
                      setUpdateId,
                      setUpdateDate,
                      setUpdateProduct,
                      updateReserveData,
                      showGroupData,
                      selectedGroupProducts,
                      tooltipPosition,
                      setTooltipPosition,
                      formattedDate,
                      setProductLabelModal,
                      productLabelModal,
                      setLabelData,
                      labelData,
                      setSubGroup,
                      setGroupName,
                      setProductName,
                      setLabelDate,
                      inputRefs,
                      flatInputIndex,
                      loader,
                      setGroupProductIds,
                      setModalInputDisabled,
                      setSubGroupName,
                      rolesData,
                      rowIndex,
                      columnCounter,
                      selectedCell,
                      setSelectedCell,
                      selectedCellsForSum,
                      setSelectedCellsForSum,
                      inputValues,
                      convertOutInputs,
                      setConvertOutInputs,
                      debouncedUpdateConvertOutData,
                      setContextMenu,
                      setSelectedCellData,
                      cellRemarks,
                      onEditActualStock,
                      hiddenReserveGroups
                    );
                  }
                  return null;
                })}


                {showGroupData && Object.entries(stockData).map(([productId, productDates]) => {
                  const dateStock = productDates[formattedDate];
                  const actualStock = dateStock ? dateStock[0]?.actual_stock : 0;

                  return (
                    <React.Fragment key={`balance-${productId}-${formattedDate}`}>
                      <td className="stock-bg fw-bold">
                        <p className="inout-tab">{actualStock || 0}</p>
                      </td>
                    </React.Fragment>
                  );
                })}
              </tr>

            );
          })}
          {/* deleteColumnModal.open && (
            <div className="modal-overlay custom-overlay product-quantity-add" role="dialog" aria-modal="true">
              <div className="modal-content custom-modal add-custom-stock bg-white">
                <div className="position-relative">
                  <div className="modal-header">
                    <h3>Delete Column</h3>
                    <img
                      style={{ top: '0', right: '0' }}
                      src={window.getPublicUrl('/assets/images/close.svg')}
                      onClick={() => !deleteColumnModal.isLoading && setDeleteColumnModal({ open: false, isLoading: false, columnData: null })}
                      className="close"
                      alt="Close"
                    />
                  </div>
                  <div className="col-sm-12 mt-3">
                    <p style={{ marginBottom: '8px' }}>
                      Are you sure you want to delete the column{' '}
                      <strong>
                        {deleteColumnModal.columnData?.label} — {deleteColumnModal.columnData?.subgroup_name}
                      </strong>?
                    </p>
                  </div>
                  <div className="col-sm-12 text-right mt-3" style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                    <button
                      className="btn btn-secondary"
                      onClick={() => setDeleteColumnModal({ open: false, isLoading: false, columnData: null })}
                      disabled={deleteColumnModal.isLoading}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={confirmDeleteColumn}
                      disabled={deleteColumnModal.isLoading}
                    >
                      {deleteColumnModal.isLoading ? 'Deleting…' : 'Delete'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) */}
          {checkEditPermission(rolesData?.permissions, 'prepack_in_out') && actualStockModal.visible && (
            <div className="modal-overlay custom-overlay product-quantity-add">
              <div className="modal-content custom-modal suplier-stock multiple-reserve add-custom-stock bg-white">
                <div className='modal-header'>
                  <h3><strong>Edit Actual Stock</strong></h3>
                  <img
                    src={window.getPublicUrl('/assets/images/close.svg')}
                    onClick={() => setActualStockModal({ visible: false, actual_stock: '', date: '', product_id: '' })}
                    className="close"
                    alt="Close"
                  />
                </div>
                <div className="suplier-data">
                  <label className='d-block qty'>Date</label>
                  <p className='mb-3'><strong>{actualStockModal.date}</strong></p>
                  <label className='d-block qty'>Actual Stock</label>
                  <input
                    type='text'
                    className="inout-tab mt-0"
                    value={actualStockModal.actual_stock}
                    onChange={e => {
                      let value = e.target.value.replace(/^0+(?=\d)/, '');
                      if (/^\d*$/.test(value)) {
                        setActualStockModal(prev => ({ ...prev, actual_stock: value === '' ? '' : value }));
                      }
                    }}
                    autoFocus
                  />
                  {actualStockLoading && (
                    <div className="spinner-border spinner-border-sm mt-2 mb-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                  <div className='modal-footer pt-3'>
                    <button
                      className='save mt-0 float-end'
                      disabled={actualStockLoading}
                      onClick={handleUpdateActualStock}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {checkEditPermission(rolesData?.permissions, 'prepack_in_out') && arrivalModalShow && (
            <div className="modal-overlay custom-overlay product-quantity-add">
              <div className="modal-content custom-modal suplier-stock  multiple-reserve add-custom-stock bg-white">
                <div className='modal-header'>
                  <h3><strong>Supplier:</strong> {arrivalModalData?.supplier_name_en}</h3>
                  <img
                    src={window.getPublicUrl('/assets/images/close.svg')}
                    onClick={() => {
                      setArrivalModalShow(false);
                      setArrivalModalData({});
                      setSelectedArrivalProductId(null);
                      setArrivalQuantityMap({});

                    }}
                    className="close"
                    alt="Close"
                  />
                </div>
                <div className="suplier-data">


                  <h6>Product:</h6>
                  <div className='suply-info'>
                    <ul>
                      {arrivalModalData?.products && arrivalModalData?.products.length > 0 &&
                        arrivalModalData.products.map((x, ind) => {
                          const isSelected = selectedArrivalProductId === x.id;
                          return (
                            <li key={x.product_id}>
                              <label className="session-check-radio">
                                <input
                                  ref={ind === 0 ? firstRadioArrivalRef : null}
                                  type="radio"
                                  name="arrivalProductSelection"
                                  checked={isSelected}
                                  onChange={() => {
                                    setSelectedArrivalProductId(x.id);
                                    setSelectedArrivalProductData(x)
                                    setArrivalQuantityMap(prev => ({
                                      ...prev,
                                      [x.id]: x.quantity
                                    }));
                                    setArrivalModalError('');
                                  }}
                                  onFocus={() => {
                                    setSelectedArrivalProductId(x.id);
                                    setSelectedArrivalProductData(x)
                                    setArrivalQuantityMap(prev => ({
                                      ...prev,
                                      [x.id]: x.quantity
                                    }));
                                    setArrivalModalError('');
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Tab') {
                                      e.preventDefault();
                                      const radioButtons = document.querySelectorAll('input[name="arrivalProductSelection"]');
                                      const currentIndex = Array.from(radioButtons).indexOf(e.target);
                                      const nextIndex = e.shiftKey ? currentIndex - 1 : currentIndex + 1;

                                      if (e.shiftKey && currentIndex === 0) {
                                        return;
                                      }

                                      if (!e.shiftKey && currentIndex === radioButtons.length - 1) {
                                        quatityRef.current?.focus();
                                        return;
                                      }

                                      if (nextIndex >= 0 && nextIndex < radioButtons.length) {
                                        radioButtons[nextIndex].focus();
                                      }
                                    }
                                  }}
                                // tabIndex={0}
                                />
                                <span className="checkmark-radio"></span>
                                <span>{x?.name_tc}</span>
                                <span>({x?.code})</span>
                                <span><b>Qty: </b>{x?.quantity}</span>
                              </label>
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                  <p className='mt-3'><strong>ATA: </strong>{arrivalModalData?.ata}</p>
                  <p className='mb-4'><strong>Order Remark:</strong> {arrivalModalData?.order_remark}</p>
                  <p className='mb-4'><strong>Container No/Air/Local/Truck:</strong> {arrivalModalData?.container_no}</p>
                  <p className='mb-0'><strong>Shipping Method:</strong> {arrivalModalData?.shipping_method_name}</p>
                  <label className='d-block qty'>Quantity</label>
                  <input
                    ref={quatityRef}
                    type='text'
                    className="inout-tab mt-0"
                    value={
                      selectedArrivalProductId
                        ? (
                          arrivalQuantityMap[selectedArrivalProductId] !== undefined
                            ? arrivalQuantityMap[selectedArrivalProductId]
                            : (
                              arrivalModalData.products &&
                              Array.isArray(arrivalModalData.products) &&
                              arrivalModalData.products.find(
                                p => p.product_id === selectedArrivalProductId
                              )?.quantity
                            ) //|| ''
                        )
                        : ''
                    }
                    onChange={e => {
                      let value = e.target.value.replace(/^0+(?=\d)/, '');
                      if (/^\d*$/.test(value)) {
                        setArrivalQuantityMap(prev => ({
                          ...prev,
                          [selectedArrivalProductId]: value === '' ? '' : value
                        }));
                      }
                    }}
                  />
                  <label className='d-block qty'>ETA</label>
                  <input
                    type="date"
                    className={`form-control date`}
                    name="eta"
                    value={arrivalModalData.eta}
                    onChange={handleDateChange}
                    min={new Date().toISOString().split('T')[0]}
                  />
                  {arrivalModalError && (
                    <div style={{ color: 'red', marginTop: 8 }}>{arrivalModalError}</div>
                  )}
                  {arrivalModalLoading && (
                    <div className="spinner-border spinner-border-sm mt-2 mb-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}

                  <div className='modal-footer pt-3'>
                    <button
                      className='save mt-0 float-end'
                      disabled={arrivalModalLoading}
                      onClick={() => {
                        handleSaveArrivalData()

                      }}
                      id='arrival_modal'
                    >
                      Save
                    </button>
                  </div>

                </div>
              </div>
            </div>
          )}

          {addColumnModal && (
            <div className="modal-overlay custom-overlay product-quantity-add" ref={modalRef} role="dialog"
              aria-modal="true" >
              <div className="modal-content custom-modal add-custom-stock multiple-reserve">
                <div className='position-relative'>
                  <div className="modal-header">
                    <h3>Add column</h3>
                    <img
                      style={{ top: '0', right: '0' }}
                      src={window.getPublicUrl('/assets/images/close.svg')}
                      onClick={() => {
                        resetAddColumnModalStates();
                      }}
                      className="close"
                      alt="Close"
                    />
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group select-drop-down">
                      <label htmlFor="customerSubGroup" className="d-block">
                        Label
                      </label>

                      <Select
                        showSearch
                        placeholder="Select Label"
                        optionFilterProp="children"
                        value={selectedLabel}
                        onChange={handleLabelChange}
                        getPopupContainer={trigger => trigger.parentNode}

                        style={{ width: '100%' }}
                      >
                        {labels?.map(label => (
                          <Option key={label} value={label}>{label}</Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group select-drop-down">
                      <label htmlFor="customerSubGroup" className="d-block">
                        Customer Group
                      </label>

                      <Select
                        showSearch
                        placeholder="Select Customer Group"
                        optionFilterProp="children"
                        value={selectedCustomerGroup}
                        onChange={handleCustomerGroupChange}
                        getPopupContainer={trigger => trigger.parentNode}

                        style={{ width: '100%' }}
                      >
                        {labelCustomerGroups?.map(labelCustomerGroup => (
                          <Option key={labelCustomerGroup.group_id} value={labelCustomerGroup.group_id}>
                            ({labelCustomerGroup.code}) {labelCustomerGroup.name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group select-drop-down">
                      <label htmlFor="customerSubGroup" className="d-block">
                        Customer Sub Group
                      </label>

                      <Select
                        showSearch
                        placeholder="Select Customer Sub Group"
                        optionFilterProp="children"
                        value={selectedCustomerSubGroup}
                        onChange={handleCustomerSubGroupChange}
                        getPopupContainer={trigger => trigger.parentNode}

                        style={{ width: '100%' }}
                      >
                        {customerSubGroups && customerSubGroups.map(customerSubGroup => (
                          <Option key={customerSubGroup.id} value={customerSubGroup.id}>
                            {customerSubGroup.name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>

                  <div className="col-sm-12 text-right mt-3">
                    <button
                      className="btn btn-primary"
                      onClick={handleColumnAdd}
                      disabled={isAddingColumn}
                    >
                      {isAddingColumn ? 'Adding...' : 'Add'}
                    </button>
                  </div>


                </div>
              </div>
            </div>
          )}
          {productLabelModal && (
            <div className="modal-overlay custom-overlay product-quantity-add" ref={modalRef} role="dialog"
              aria-modal="true" >
              <div className="modal-content custom-modal add-custom-stock multiple-reserve">
                <div className='position-relative'>
                  <div className="modal-header">
                    <h3>Select Group and add Quantity</h3>
                    <img
                      style={{ top: '0', right: '0' }}
                      src={window.getPublicUrl('/assets/images/close.svg')}
                      onClick={() => {
                        setProductLabelModal(false);
                        setReserveModalUpdateData([]);
                        setReserveModalError('');
                        setSelectedProductId(null)
                        setGroupProductIds(null)

                      }}
                      className="close"
                      alt="Close"
                    />
                  </div>

                  {/* Modal content remains the same */}
                  <div className='profuct-group-overflow'>
                    <ul>
                      {labelData && labelData[0]?.groupLabel?.length > 0 &&
                        [...labelData[0].groupLabel]
                          .sort((a, b) => {
                            const qtyA = labelData[0]?.subGroups?.find(
                              (subgroup) => a?.customer_group_id === subgroup.customer_group_id
                            )?.quantity || 0;
                            const qtyB = labelData[0]?.subGroups?.find(
                              (subgroup) => b?.customer_group_id === subgroup.customer_group_id
                            )?.quantity || 0;
                            return qtyB - qtyA; // Descending order (high to low)
                          })
                          .map((x, index) => { //groupLabel is customerGroups in a speicific label
                            const isSelected = selectedProductId === x.customer_group_id;
                            return (
                              <li key={x.customer_group_id}>
                                <div className=''>
                                  <label className="session-check-radio">
                                    <input
                                      ref={index === 0 ? firstRadioRefProductLabel : null}
                                      type="radio"
                                      name="productSelection"
                                      checked={isSelected}
                                      onChange={() => {
                                        setSelectedProductId(x.customer_group_id);
                                        setQuantityValue(labelData[0]?.subGroups?.find(
                                          (subgroup) => x?.customer_group_id === subgroup.customer_group_id
                                        )?.quantity || 0);
                                        setReserveModalError('');
                                        setGroupName(x?.customer_group_id);
                                      }}
                                      onFocus={() => {
                                        setSelectedProductId(x.product_id);
                                        setQuantityValue(labelData[0]?.subGroups?.find(
                                          (subgroup) => x?.customer_group_id === subgroup.customer_group_id
                                        )?.quantity || 0);
                                        setReserveModalError('');
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Tab') {
                                          e.preventDefault();
                                          const radioButtons = document.querySelectorAll('input[name="productSelection"]');
                                          const currentIndex = Array.from(radioButtons).indexOf(e.target);
                                          const nextIndex = e.shiftKey ? currentIndex - 1 : currentIndex + 1;

                                          if (e.shiftKey && currentIndex === 0) {
                                            return;
                                          }

                                          if (!e.shiftKey && currentIndex === radioButtons.length - 1) {
                                            quatityRef.current?.focus();
                                            return;
                                          }

                                          if (nextIndex >= 0 && nextIndex < radioButtons.length) {
                                            radioButtons[nextIndex].focus();
                                          }
                                        }
                                      }}
                                    // tabIndex={0}
                                    />
                                    <span className="checkmark-radio"> </span>
                                    {/* <span>{x?.label}  </span> */}
                                    <span><b className='ps-0'>Group: </b>{x?.name}</span>{' '}
                                    <span><b> SubGroup: </b>{subGroupName} </span>

                                    {/* <span>({x?.name})</span> */}
                                    <span><b>Qty : </b>{labelData[0]?.subGroups?.find(
                                      (subgroup) => x?.customer_group_id === subgroup.customer_group_id
                                    )?.quantity || 0}</span>
                                  </label>
                                </div>
                              </li>
                            )
                          })}
                    </ul>
                  </div>

                  <label className='d-block qty'>Quantity</label>
                  <input
                    ref={quatityRef}
                    type='text'
                    className="inout-tab mt-0"
                    value={
                      (() => {
                        // if (!Array.isArray(labelData) || labelData[0]?.subGroups?.length === 0) return '';
                        // const selected = labelData[0]?.subGroups.find(x => x.id === selectedProductId);
                        const selected = labelData[0]?.subGroups.find(
                          (subgroup) => selectedProductId === subgroup.customer_group_id
                        );

                        const val = selected ? (quantityValue ?? selected.quantity ?? '') : quantityValue;
                        return typeof val === 'string' ? val.replace(/^0+(?=\d)/, '') : val;
                      })()
                    }
                    onFocus={(e) => {
                      if (e.target.value === '0') {
                        setQuantityValue('');
                      }
                    }}
                    onChange={(e) => {
                      let value = e.target.value.replace(/^0+(?=\d)/, '');
                      if (/^\d*$/.test(value)) {
                        setQuantityValue(value === '' ? '' : value);
                      }
                    }}
                    // tabIndex={-1}
                    disabled={modalInputDisabled}

                  />

                  {reserveModalError && (
                    <div style={{ color: 'red', marginTop: 8 }}>{reserveModalError}</div>
                  )}

                  {toastMessage && (
                    <div className="spinner-border spinner-border-sm mt-2 mb-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}

                  <div className='modal-footer'>
                    <button
                      id="modal-save-btnp"
                      type="button"
                      className='save mt-0 float-end'
                      disabled={toastMessage || modalInputDisabled || !selectedProductId}
                      onClick={() => {
                        if (modalInputDisabled) return;
                        if (!Array.isArray(labelData) || labelData.length === 0) {
                          setReserveModalError('No products available.');
                          return;
                        }
                        const selectedProduct = labelData[0]?.subGroups.find(
                          (subgroup) => selectedProductId === subgroup.customer_group_id
                        );
                        const cleanQuantity = parseInt(quantityValue, 10) || 0;
                        if (selectedProduct) {
                          updateReserveData(
                            selectedProduct,
                            quantityValue,
                            `sales-${selectedProduct?.id}`
                          );
                        } else {
                          updateReserveData(
                            {
                              customer_group_name: selectedProductId,
                              customer_sub_group_name: subGroup,
                              product_name: productName,
                              date: labelDate,
                              type: 'product',
                              // product_group_name:productName,
                            },
                            quantityValue,
                            `sales-${selectedProduct?.id}`
                          );
                        }
                        setReserveModalError('');
                      }}
                    // tabIndex="0"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {productGroupLabelModal && (
            <div className="modal-overlay custom-overlay product-quantity-add" ref={modalRef} role="dialog"
              aria-modal="true" >
              <div className="modal-content custom-modal add-custom-stock multiple-reserve">
                <div className='position-relative'>
                  <div className="modal-header">
                    <h3>Select Customer Group and add Quantity</h3>
                    <img
                      style={{ top: '0', right: '0' }}
                      src={window.getPublicUrl('/assets/images/close.svg')}
                      onClick={() => {
                        setProductGroupLabelModal(false);
                        setReserveModalUpdateData([]);
                        setReserveModalError('');
                        setSelectedProductId(null)
                      }}
                      className="close"
                      alt="Close"
                    />
                  </div>
                  <div className='profuct-group-overflow'>
                    <ul>
                      {/* Modal content remains the same */}
                      {labelData
                        ?.slice()
                        .sort((objA, objB) => {
                          // Each obj has one groupLabel and potentially subGroups
                          // Get max quantity from subGroups for each obj
                          const maxQtyA = objA?.subGroups?.length > 0
                            ? Math.max(...objA.subGroups.map(sg => sg?.quantity || 0))
                            : 0;
                          const maxQtyB = objB?.subGroups?.length > 0
                            ? Math.max(...objB.subGroups.map(sg => sg?.quantity || 0))
                            : 0;

                          return maxQtyB - maxQtyA; // Descending order (high to low)
                        })
                        .map((obj, index) => {


                          return obj.groupLabel
                            ?.slice()
                            .sort((a, b) => {
                              // Find matching subGroups for each groupLabel item
                              const subGroupsA = (obj?.subGroups || []).filter(
                                (sub) => sub?.customer_group_id === a?.customer_group_id || sub?.customer_group_id === a?.id
                              );
                              const subGroupsB = (obj?.subGroups || []).filter(
                                (sub) => sub?.customer_group_id === b?.customer_group_id || sub?.customer_group_id === b?.id
                              );

                              // Get max quantity from matching subGroups
                              const maxQtyA = subGroupsA.length > 0
                                ? Math.max(...subGroupsA.map(sg => sg?.quantity || 0))
                                : 0;
                              const maxQtyB = subGroupsB.length > 0
                                ? Math.max(...subGroupsB.map(sg => sg?.quantity || 0))
                                : 0;

                              return maxQtyB - maxQtyA; // Descending order (high to low)
                            })
                            .map((x, groupIndex) => {

                              const matchingSubGroups = (obj?.subGroups || []).filter(
                                (sub) => sub?.customer_group_id === x?.customer_group_id || sub?.customer_group_id === x?.id
                              );
                              if (matchingSubGroups?.length == 0) {
                                handleGetMainProduct(productName)
                              }
                              const noProductData = fallbackProducts[productName];
                              // Fallback: If no matching subGroups, render one dummy item
                              const renderList = matchingSubGroups.length > 0
                                ? matchingSubGroups.slice().sort((a, b) => (b?.quantity || 0) - (a?.quantity || 0))
                                : [{ id: x?.customer_group_id }];

                              return renderList.map((subGroup, i) => {
                                const productId = subGroup?.id || x?.customer_group_id;
                                const isSelected = selectedProductId === productId;
                                

                                return (

                                  <li key={`${index}-${groupIndex}-${i}`}>
                                    <div>
                                      <label className="session-check-radio">
                                        <input
                                          ref={index === 0 && groupIndex === 0 && i === 0 ? groupRef : null}
                                          type="radio"
                                          name="productSelection"
                                          checked={isSelected}
                                          onChange={() => {
                                            setSelectedProductId(productId);
                                            setQuantityValue(subGroup?.quantity || 0);
                                            setReserveModalError('');
                                            setGroupName(x?.customer_group_id);
                                          }}
                                          onFocus={() => {
                                            setSelectedProductId(productId);
                                            setQuantityValue(subGroup?.quantity || 0);
                                            setReserveModalError('');
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === 'Tab') {
                                              e.preventDefault();
                                              const radioButtons = document.querySelectorAll('input[name="productSelection"]');
                                              const currentIndex = Array.from(radioButtons).indexOf(e.target);
                                              const nextIndex = e.shiftKey ? currentIndex - 1 : currentIndex + 1;
                                              if (e.shiftKey && currentIndex === 0) {
                                                return;
                                              }

                                              if (!e.shiftKey && currentIndex === radioButtons.length - 1) {
                                                quatityRef.current?.focus();
                                                return;
                                              }

                                              if (nextIndex >= 0 && nextIndex < radioButtons.length) {
                                                radioButtons[nextIndex].focus();
                                              }
                                            }
                                          }}
                                        // tabIndex={-1}
                                        />
                                        <span className="checkmark-radio"></span>
                                        <span><b className='ps-0'>Group: </b>{x?.name}</span>
                                        <span>({x?.code})</span>
                                        <span><b>Product:  </b> {subGroup?.product_name_tc || noProductData?.name_tc}</span>
                                        <span>({subGroup?.product_code || noProductData?.code})</span>
                                        <span><b>Qty: </b>{subGroup?.quantity || 0}</span>
                                      </label>
                                    </div>
                                  </li>
                                );
                              });
                            });

                        })}
                    </ul>
                  </div>




                  <label className='d-block qty'>Quantity</label>
                  <input
                    ref={quatityRef}
                    type='text'
                    className="inout-tab mt-0"
                    value={quantityValue}
                    onChange={(e) => {
                      let value = e.target.value.replace(/^0+(?=\d)/, '');
                      if (/^\d*$/.test(value)) {
                        setQuantityValue(value === '' ? '' : value);
                      }
                    }}
                    // tabIndex={-1}
                    disabled={modalInputDisabled}
                  />

                  {reserveModalError && (
                    <div style={{ color: 'red', marginTop: 8 }}>{reserveModalError}</div>
                  )}

                  {toastMessage && (
                    <div className="spinner-border spinner-border-sm mt-2 mb-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}

                  <div className='modal-footer'>
                    <button
                      id="modal-save-btng"
                      type="button"
                      className='save mt-0 float-end'
                      disabled={toastMessage || modalInputDisabled}
                      onClick={() => {
                        if (modalInputDisabled) return;
                        // if (!Array.isArray(reserveModalUpdateData) || reserveModalUpdateData.length === 0) {
                        //   setReserveModalError('No products available.');
                        //   return;
                        // }
                        // const selectedProducts = labelData[0]?.groupLabel.find(x => x.id === selectedProductId);
                        // const selectedProductd = labelData[0]?.subGroups.find(
                        //   (subgroup) => selectedProductId === subgroup.customer_group_id
                        // );
                        const selectedObject = labelData
                          .flatMap(item => item.subGroups || [])
                          .find(sub => sub.id === selectedProductId);
                        // const selectedProduct = selectedProducts ||selectedProductd
                        const selectedProduct = selectedObject
                        // if (!selectedProduct && !selectedProducts) {
                        //   setReserveModalError('Selected product not found.');
                        //   return;
                        // }
                        const cleanQuantity = parseInt(quantityValue, 10) || 0;
                        if (selectedProduct) {
                          updateReserveData(
                            selectedProduct,
                            quantityValue,
                            `sales-${selectedProduct?.id}`
                          );
                        } else {
                          updateReserveData(
                            {
                              customer_group_name: selectedProductId,
                              customer_sub_group_name: subGroup,
                              product_name: productName,
                              date: labelDate,
                              type: 'productGroup',
                              product_group_name: productName
                            },
                            quantityValue,
                            `sales-${selectedProduct?.id}`
                          );
                        }


                        if (!Array.isArray(labelData) || labelData.length === 0) {
                          setReserveModalError('No products available.');
                          return;
                        }


                        setReserveModalError('');

                      }

                      }
                    // tabIndex={-1}
                    >
                      Save
                    </button>
                  </div>

                </div>
              </div>
            </div>
          )}
          {/* //modal in case of group convert out */}
          <ConvertOutModal
            modalConvertOut={modalConvertOut}
            setModalConvertOut={setModalConvertOut}
            modalRef={modalRef}
            rawProductOptions={rawProductOptions}
            selectedRawProductForModal={selectedRawProductForModal}
            setSelectedRawProductForModal={setSelectedRawProductForModal}
            setSelectedManualConvertOutPrepackProduct={setSelectedManualConvertOutPrepackProduct}
            setSelectedManualConvertOutQuantity={setSelectedManualConvertOutQuantity}
            prepackProductsForDropdown={prepackProductsForDropdown}
            selectedManualConvertOutPrepackProduct={selectedManualConvertOutPrepackProduct}
            selectedManualConvertOutDate={selectedManualConvertOutDate}
            selectedManualConvertOutQuantity={selectedManualConvertOutQuantity}
            isFetchingQuantity={isFetchingQuantity}
            setIsFetchingQuantity={setIsFetchingQuantity}
            setSelectedManualConvertOutRawProductId={setSelectedManualConvertOutRawProductId}
            setSelectedManualConvertOutFinishedProductId={setSelectedManualConvertOutFinishedProductId}
            setSelectedManualConvertOutDate={setSelectedManualConvertOutDate}
            setRawProductOptions={setRawProductOptions}
            debouncedUpdateConvertOutData={debouncedUpdateConvertOutData}
          />
        </tbody>
      </table>

      {tooltipPosition.visible && tooltipPosition.arrival && (
        <div style={tooltipStyle}
          onMouseEnter={() => {
            clearTimeout(hideTooltipTimeout);
            setTooltipPosition(prev => ({ ...prev, visible: true }));
          }}
          onMouseLeave={() => {
            setTooltipPosition(prev => ({ ...prev, visible: false }));
          }}
        >
          <div className='suplier-data'>
            <p><strong>Supplier:</strong> {tooltipPosition.arrival?.supplier_name_en}</p>
            <h6>Product:</h6>
            <div className='product-data-scroll'>
              {tooltipPosition.arrival?.products && tooltipPosition.arrival.products.length > 0 &&
                tooltipPosition.arrival.products.map((x, i) => (
                  <div key={i} className='row'>
                    <div className='col-md-5 data-fonts'>
                      <p>{x?.name_tc}</p>
                    </div>
                    <div className='col-md-7'>
                      <div className='d-flex gap-2 data-fonts'>
                        <p><strong>Qty</strong>{` :${x?.quantity}`}</p>
                        <p><strong>Barcode</strong>{` : ${x?.barcode != null ? x?.barcode : ''}`}</p>
                      </div>
                    </div>
                  </div>

                ))
              }
            </div>
            <p><strong>ATA: </strong>{tooltipPosition.arrival?.ata}</p>
            <p className='mb-0'><strong>Order Remark:</strong> {tooltipPosition.arrival?.order_remark}</p>
            <p className='mb-0'><strong>Container No/Air/Local/Truck:</strong> {tooltipPosition.arrival?.container_no}</p>
            <p className='mb-0'><strong>Shipping Method:</strong> {tooltipPosition.arrival?.shipping_method_name}</p>
          </div>
        </div>
      )}
      {tooltipPosition.visible && tooltipPosition.promotionType && (
        <div style={tooltipStyle}>
          <div className='suplier-data'>
            <p><strong>Promotion Type: </strong> {tooltipPosition.promotionType?.promotion_type}</p>
            <p><strong>Product: </strong>{tooltipPosition.promotionType?.product_name}</p>
            <p><strong>Date: </strong>{tooltipPosition.promotionType?.product_date}</p>
          </div>
        </div>
      )}
      {tooltipPosition.visible && tooltipPosition.unitPriceValue && (
        <div style={{
          ...tooltipStyle,
          minWidth: '200px',
          maxWidth: '300px',
          top: tooltipPosition.promotionType ? `${tooltipPosition.y + 110}px` : `${tooltipPosition.y}px`
        }}>
          <p className="mb-0">Unit Price: {tooltipPosition.unitPriceValue}</p>
        </div>
      )}

      {/* Cell Context Menu */}
      {contextMenu && (
        <CellContextMenu
          x={contextMenu.x}
          y={contextMenu.y}
          onClose={() => setContextMenu(null)}
          onAddRemark={handleAddRemark}
          onViewRemarks={handleViewRemarks}
          remarkCount={selectedCellData ? getCellRemarkCount(selectedCellData) : 0}
          onViewHistories={handleViewHistories}
          showViewHistories={selectedCellData?.cell_type === 'convert_out' && (selectedCellData?.raw_product_id || selectedCellData?.raw_product_ids) && selectedCellData?.finished_product_id}
          showArrivalActions={!!selectedCellData?.arrival_id_raw}
          onCloneArrival={handleCloneArrival}
          onDeleteArrival={handleDeleteArrival}
          permissions={rolesData?.permissions}
        />
      )}

      {/* Cell Remark Modal */}
      {remarkModal.show && selectedCellData && (
        <CellRemarkModal
          isOpen={remarkModal.show}
          onClose={() => {
            setRemarkModal({ show: false, mode: 'add', data: [] });
            setSelectedCellData(null);
          }}
          cellData={selectedCellData}
          onRemarkAdded={handleRemarkAdded}
          existingRemarks={remarkModal.data}
        />
      )}

      {/* Convert Out History Modal */}
      {historyModal.visible && (
        <ConvertOutHistoryModal
          isOpen={historyModal.visible}
          onClose={() => setHistoryModal({ visible: false, rawProductId: null, finishedProductId: null, date: null })}
          rawProductId={historyModal.rawProductId}
          finishedProductId={historyModal.finishedProductId}
          executionDate={historyModal.date}
        />
      )}

      {/* Clone Arrival Modal */}
      <Modal
        open={cloneModal.open}
        onCancel={() => setCloneModal(CLONE_INITIAL)}
        footer={null}
        width={1100}
        title="Clone Arrival"
        destroyOnClose
        style={{ top: 20 }}
      >
        {cloneModal.open && (
          <div className="modal-add-edit-arrival">
            {cloneModal.isLoading ? (
              <div className="d-flex justify-content-center p-4">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <AddEditArrival
                setMethodType={() => setCloneModal(CLONE_INITIAL)}
                resetForm={() => setCloneModal(CLONE_INITIAL)}
                touched={cloneModal.touched}
                errors={cloneModal.errors}
                formData={cloneModal.formData}
                handleInputChange={(e) => {
                  const { name, value } = e.target;
                  updateClone({ formData: { ...cloneModal.formData, [name]: value } });
                }}
                handleBlur={(e) => {
                  const { name } = e.target;
                  updateClone({ touched: { ...cloneModal.touched, [name]: true } });
                }}
                suppliers={cloneModal.suppliers}
                shippingMethods={cloneModal.shippingMethods}
                handleDateChange={(e) => {
                  const { name, value } = e.target;
                  updateClone({ formData: { ...cloneModal.formData, [name]: value } });
                }}
                searchTerm={cloneModal.searchTerm || ''}
                setIsDropdownOpen={() => {}}
                isDropdownOpen={false}
                filteredProducts={[]}
                selectedProducts={[]}
                setSearchTerm={() => {}}
                handleProductClick={() => {}}
                setShowAddProductModal={() => {}}
                setProductSearchQuery={() => {}}
                setAvailableProducts={() => {}}
                setSelectedProducts={() => {}}
                fetchAvailableProducts={() => {}}
                toggleAllProductsCheckbox={(checked) => {
                  updateClone({ selectedProducts: cloneModal.selectedProducts.map(p => ({ ...p, checked })) });
                }}
                products={[]}
                toggleProductCheckbox={(id, checked) => {
                  const updated = cloneModal.selectedProducts.map(p =>
                    p.id === id ? { ...p, checked } : p
                  );
                  updateClone({ selectedProducts: updated });
                }}
                handleProductChange={(id, field, value) => {
                  const updated = cloneModal.selectedProducts.map(p =>
                    p.id === id ? { ...p, [field]: value } : p
                  );
                  updateClone({ selectedProducts: updated, productList: updated });
                }}
                removeProduct={(id) => {
                  const updated = cloneModal.selectedProducts.filter(p => p.id !== id);
                  updateClone({ selectedProducts: updated });
                }}
                handleAddArrival={handleCloneArrivalSave}
                isLoading={cloneModal.isLoading}
                type="clone"
                arrivalToEdit={cloneModal.arrival}
                selectedShowProducts={cloneModal.selectedProducts}
                resetFormArrival={() => setCloneModal(CLONE_INITIAL)}
                setFilterData={(data) => updateClone({ filterData: data })}
                filterDatas={cloneModal.filterData}
                productlist={cloneModal.productList}
                setProductList={(updater) => {
                  const next = typeof updater === 'function' ? updater(cloneModal.productList) : updater;
                  updateClone({ productList: next });
                }}
                setSelectedShowProducts={(updater) => {
                  const next = typeof updater === 'function' ? updater(cloneModal.selectedProducts) : updater;
                  updateClone({ selectedProducts: next });
                }}
                isModal={true}
              />
            )}
          </div>
        )}
      </Modal>

      {/* Delete Arrival Modal */}
      <Modal
        open={deleteModal.open}
        onCancel={() => setDeleteModal({ open: false, isLoading: false, cellData: null })}
        title="Delete Arrival"
        okText="Delete"
        okButtonProps={{ danger: true, loading: deleteModal.isLoading }}
        onOk={handleDeleteArrivalConfirm}
        cancelButtonProps={{ disabled: deleteModal.isLoading }}
      >
        <p>Are you sure you want to delete this arrival? This action cannot be undone.</p>
        {deleteModal.cellData?.productName && (
          <p><strong>Arrival:</strong> {deleteModal.cellData.productName}</p>
        )}
      </Modal>
    </>
  );
};

export default GenerateTable;